
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hFGQl", function(module, exports) {
const $d3e8bd0515c02c91$export$8b02acc4219d8357 = 'content-metadata-jira';
const $d3e8bd0515c02c91$export$a93781d2f10a1a54 = 'content-metadata-attachments';
const $d3e8bd0515c02c91$export$126027a563ee39b2 = 'content-metadata-page-restrictions';
const $d3e8bd0515c02c91$export$e5b04880f6b7bed = 'draft-status-lozenge';
const $d3e8bd0515c02c91$export$b6c67256b8045624 = 'status-lozenge-scheduled';
const $d3e8bd0515c02c91$export$1b048ac0db68f7ab = 'rte-button-restrictions';
const $d3e8bd0515c02c91$export$607df6eced5a588c = 'inviteToEdit';
const $d3e8bd0515c02c91$export$c8362b8678d6b894 = 'com.addonengine.analytics__analytics-content-byline-item';
const $d3e8bd0515c02c91$export$de7935ab18e02484 = 'com.addonengine.analytics__analytics-content-menu-item';
const $d3e8bd0515c02c91$export$a643e9449b465583 = 'com.addonengine.analytics.moderate__analytics-content-menu-item';
module.exports["CONTENT_METADATA_JIRA_ID"] = $d3e8bd0515c02c91$export$8b02acc4219d8357;
module.exports["CONTENT_METADATA_ATTACHMENTS_ID"] = $d3e8bd0515c02c91$export$a93781d2f10a1a54;
module.exports["CONTENT_METADATA_PAGE_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$126027a563ee39b2;
module.exports["DRAFT_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$e5b04880f6b7bed;
module.exports["SCHEDULED_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$b6c67256b8045624;
module.exports["EDIT_PAGE_METADATA_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$1b048ac0db68f7ab;
module.exports["INVITE_TO_EDIT_ID"] = $d3e8bd0515c02c91$export$607df6eced5a588c;
module.exports["ANALYTICS_ADDON_BYLINE_ID"] = $d3e8bd0515c02c91$export$c8362b8678d6b894;
module.exports["ANALYTICS_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$de7935ab18e02484;
module.exports["ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$a643e9449b465583;

});

parcelRegister("4aGJ9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7boqA = parcelRequire("7boqA");


var $ln0hx = parcelRequire("ln0hx");


var $irVI7 = parcelRequire("irVI7");


var $gw4Bt = parcelRequire("gw4Bt");





var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $b9k8w = parcelRequire("b9k8w");

var $8Iwqw = parcelRequire("8Iwqw");

var $8lt1a = parcelRequire("8lt1a");


var $3cW6b = parcelRequire("3cW6b");


var $iV65j = parcelRequire("iV65j");


var $cLo2u = parcelRequire("cLo2u");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $lsxnT = parcelRequire("lsxnT");


var $bQm3c = parcelRequire("bQm3c");


var $ivb8S = parcelRequire("ivb8S");


var $1kHsc = parcelRequire("1kHsc");





var $aJPUt = parcelRequire("aJPUt");


var $3jRrs = parcelRequire("3jRrs");


var $kM55L = parcelRequire("kM55L");


var $7aRa9 = parcelRequire("7aRa9");


var $6DT7W = parcelRequire("6DT7W");





var $dPJCf = parcelRequire("dPJCf");

const $913c9f7b92c5afc8$var$useAccountIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('accountId');
const $913c9f7b92c5afc8$var$useUsernameQueryParam = (0, $dPJCf.createSingleQueryParamHook)('username');
const $913c9f7b92c5afc8$var$useGrantAccessQueryParam = (0, $dPJCf.createSingleQueryParamHook)('grantAccess');
const $913c9f7b92c5afc8$export$2914b3c0c287db = ()=>{
    const accountIdRaw = $913c9f7b92c5afc8$var$useAccountIdQueryParam();
    const username = $913c9f7b92c5afc8$var$useUsernameQueryParam();
    const grantAccess = $913c9f7b92c5afc8$var$useGrantAccessQueryParam();
    const shouldShowGrantAccess = Boolean(grantAccess && accountIdRaw || username);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const clearGrantAccessQueryParams = (0, $cozmU.useCallback)(()=>{
        setQueryParams({
            grantAccess: undefined,
            accessType: undefined,
            accountId: undefined,
            username: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    return {
        shouldShowGrantAccess: shouldShowGrantAccess,
        clearGrantAccessQueryParams: clearGrantAccessQueryParams
    };
};



var $kvJHJ = parcelRequire("kvJHJ");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $e4o8D = parcelRequire("e4o8D");


var $hkzol = parcelRequire("hkzol");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $lfFzM = parcelRequire("lfFzM");


var $eoU1C = parcelRequire("eoU1C");


var $d35qt = parcelRequire("d35qt");


var $dA1Sn = parcelRequire("dA1Sn");





var $foQ4a = parcelRequire("foQ4a");

















var $d9tcB = parcelRequire("d9tcB");





var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");




/**
 * @generated SignedSource<<03ad2e38b50157b51748c21f04add1b9>>
 * @relayHash e476390ffa12b3e505bd7e8ac519e061
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755
const $927357fa0afdf6f0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accessType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceRoleId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subjects"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "accessType",
                            "variableName": "accessType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceRoleId",
                            "variableName": "spaceRoleId"
                        },
                        {
                            "kind": "Variable",
                            "name": "subjects",
                            "variableName": "subjects"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ResolveRestrictionsPayload",
            "kind": "LinkedField",
            "name": "resolveRestrictionsForSubjects",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "e476390ffa12b3e505bd7e8ac519e061",
            "id": "21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "operationKind": "mutation",
            "text": "mutation useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
        }
    };
}();
$927357fa0afdf6f0$var$node.hash = "20811ee88362a051210b331b739d34c1";
var $927357fa0afdf6f0$export$2e2bcd8739ae039 = $927357fa0afdf6f0$var$node;


/**
 * @generated SignedSource<<bf8bfb80a897d9fda93d449ba1f82589>>
 * @relayHash 3ba2473df321be430db6c856602e1cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482
const $b4dea9a5255d2c1f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateContentAccessRequestInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "updateContentAccessRequestInput",
                    "variableName": "updateContentAccessRequestInput"
                }
            ],
            "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
            "kind": "LinkedField",
            "name": "confluence_updateContentAccessRequest",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3ba2473df321be430db6c856602e1cfc",
            "id": "276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "operationKind": "mutation",
            "text": "mutation useRealtimeAccessRequestsFlagsMutation($cloudId:ID!,$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId,updateContentAccessRequestInput:$updateContentAccessRequestInput){success,errors{message}}}"
        }
    };
}();
$b4dea9a5255d2c1f$var$node.hash = "42de35f8c9cecb62158728d903eff6a2";
var $b4dea9a5255d2c1f$export$2e2bcd8739ae039 = $b4dea9a5255d2c1f$var$node;


/**
 * @generated SignedSource<<02a6cb4a120ec245a4a1e2f7451520f5>>
 * @relayHash cc07dc4570c5f23dcae6dba3e01bc64f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884
const $4ea839717298c820$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 5,
            "kind": "LocalArgument",
            "name": "duration"
        },
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "duration",
                    "variableName": "duration"
                },
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "ConfluenceLatestPendingRequests",
            "kind": "LinkedField",
            "name": "confluence_getLatestPendingRequests",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceContentAccessRequest",
                    "kind": "LinkedField",
                    "name": "latestPendingRequest",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "requestAccessType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creatorAaid"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationDateTimestamp"
                        },
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cc07dc4570c5f23dcae6dba3e01bc64f",
            "id": "869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "operationKind": "query",
            "text": "query useRealtimeAccessRequestsFlagsQuery($cloudId:ID!,$contentId:ID!,$duration:Int=5,$limit:Int=10,$start:String){confluence_getLatestPendingRequests(cloudId:$cloudId,contentId:$contentId,duration:$duration,limit:$limit,start:$start){latestPendingRequest{id,requestAccessType,creatorAaid,creationDateTimestamp,user{id,displayName,photos{isPrimary,value}}}}}"
        }
    };
}();
$4ea839717298c820$var$node.hash = "b94cab17722d3b349c6aeac7cfa04a8f";
var $4ea839717298c820$export$2e2bcd8739ae039 = $4ea839717298c820$var$node;












var $6B1vK = parcelRequire("6B1vK");


var $i9VoI = parcelRequire("i9VoI");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $iquRY = parcelRequire("iquRY");


var $8aF6s = parcelRequire("8aF6s");


var $eRpR8 = parcelRequire("eRpR8");


var $7Sm4c = parcelRequire("7Sm4c");


var $dwkNQ = parcelRequire("dwkNQ");


var $7QoAs = parcelRequire("7QoAs");


var $f2UnK = parcelRequire("f2UnK");


var $1UApO = parcelRequire("1UApO");


var $2Oud5 = parcelRequire("2Oud5");

const $ba14d5ed8e7789e1$export$7e0819e7cb643ce3 = 525600;
const $ba14d5ed8e7789e1$export$c47be26a650fe21 = 5;
const $ba14d5ed8e7789e1$export$e58e41b464377560 = $ba14d5ed8e7789e1$export$c47be26a650fe21 * 60000;
const $ba14d5ed8e7789e1$export$b8de370ad22b4906 = (0, $1UApO.keys).LAST_SHOWN_REALTIME_REQUEST_CREATED_AT;
const $ba14d5ed8e7789e1$export$4000ed65840ab68a = (timestamp)=>{
    return Date.now() - timestamp < $ba14d5ed8e7789e1$export$e58e41b464377560;
};
const $ba14d5ed8e7789e1$export$3dee0973a5558286 = (timestamp)=>!$ba14d5ed8e7789e1$export$4000ed65840ab68a(timestamp);
const $ba14d5ed8e7789e1$export$289c54b917400e1c = (contentId, newTimestamp)=>{
    (0, $2Oud5.setCachedTuple)(contentId, newTimestamp, $ba14d5ed8e7789e1$export$b8de370ad22b4906, $ba14d5ed8e7789e1$export$4000ed65840ab68a);
};
const $ba14d5ed8e7789e1$export$8d67ec31af2e3b08 = (contentId, incomingRequestTimestamp)=>{
    return incomingRequestTimestamp > (0, $2Oud5.getCachedTimestamp)(contentId, $ba14d5ed8e7789e1$export$b8de370ad22b4906) && $ba14d5ed8e7789e1$export$4000ed65840ab68a(incomingRequestTimestamp);
};
const $ba14d5ed8e7789e1$export$37d57e4c435593ab = (contentId)=>{
    (0, $2Oud5.removeCachedTuple)(contentId, $ba14d5ed8e7789e1$export$b8de370ad22b4906, $ba14d5ed8e7789e1$export$3dee0973a5558286);
};












var $bcDqz = parcelRequire("bcDqz");


var $9QsA9 = parcelRequire("9QsA9");


var $1chEN = parcelRequire("1chEN");

const $1ca745aa2c0dd46c$var$i18n = (0, $kSwu1.defineMessages)({
    singleRequestTitleView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.single-request-title-view",
        defaultMessage: "{name} wants to view this content"
    },
    singleRequestTitleEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.single-request-title-edit",
        defaultMessage: "{name} wants to edit this content"
    },
    twoRequestsTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.two-requests-title",
        defaultMessage: "{firstName} and {secondName} want to access this content"
    },
    multipleRequestsTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.multiple-requests-title",
        defaultMessage: "{firstName} and {remainingCount} others want to access this content"
    },
    spaceAndParentRestriction: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.space-and-parent-restriction",
        defaultMessage: "They'll also need to be added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}."
    },
    spaceRestrictionOnly: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.space-restriction-only",
        defaultMessage: "They'll also need to be added to the space."
    },
    parentRestrictionOnly: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.parent-restriction-only",
        defaultMessage: "They'll also need to be added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}."
    },
    approveButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.approve-button",
        defaultMessage: "Approve"
    },
    viewDetailsButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.view-details-button",
        defaultMessage: "View details"
    },
    denyButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.deny-button",
        defaultMessage: "Deny"
    },
    reviewRequestsButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.review-requests-button",
        defaultMessage: "Review requests"
    },
    successSpaceAndParentRestrictionView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-and-parent-restriction-view",
        defaultMessage: "{displayName} was added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}. They can now view this content."
    },
    successSpaceAndParentRestrictionEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-and-parent-restriction-edit",
        defaultMessage: "{displayName} was added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}. They can now edit this content."
    },
    successSpaceRestrictionOnlyView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-restriction-only-view",
        defaultMessage: "{displayName} was added to the space and can now view this content."
    },
    successSpaceRestrictionOnlyEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-restriction-only-edit",
        defaultMessage: "{displayName} was added to the space and can now edit this content."
    },
    successParentRestrictionOnlyView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-parent-restriction-only-view",
        defaultMessage: "{displayName} was added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}} and can now view this content."
    },
    successParentRestrictionOnlyEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-parent-restriction-only-edit",
        defaultMessage: "{displayName} was added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}} and can now edit this content."
    },
    successNoRestrictionView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-no-restriction-view",
        defaultMessage: "{displayName} can now view this content."
    },
    successNoRestrictionEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-no-restriction-edit",
        defaultMessage: "{displayName} can now edit this content."
    }
});
const $1ca745aa2c0dd46c$export$9ddb107f546f744e = (requests, formatMessage)=>{
    if (requests.length === 1) {
        const onlyRequest = requests[0];
        const name = onlyRequest?.user?.displayName ?? '';
        const userId = onlyRequest?.user?.id ?? null;
        const accessType = onlyRequest?.requestAccessType;
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.singleRequestTitleEdit : $1ca745aa2c0dd46c$var$i18n.singleRequestTitleView;
        // Get the translated template (e.g. "{name} wants to view this content")
        // and split around the {name} placeholder so we can inject the hover card trigger.
        const translated = formatMessage(messageKey, {
            name: '\x00'
        });
        const [before, after] = translated.split('\x00');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, before, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9QsA9.AccessRequestProfileCardTrigger), {
            userId: userId,
            displayName: name,
            offset: [
                0,
                32
            ]
        }, name), after);
    }
    if (requests.length > 1) {
        const firstName = requests[0]?.user?.displayName;
        if (requests.length === 2) {
            const secondName = requests[1]?.user?.displayName;
            return formatMessage($1ca745aa2c0dd46c$var$i18n.twoRequestsTitle, {
                firstName: firstName,
                secondName: secondName
            });
        }
        const remainingCount = requests.length - 1;
        return formatMessage($1ca745aa2c0dd46c$var$i18n.multipleRequestsTitle, {
            firstName: firstName,
            remainingCount: remainingCount
        });
    }
    // Should not happen, because method gets invoked if there's at least one request
    return '';
};
const $1ca745aa2c0dd46c$export$6fedf4d3a712a334 = (restrictedUserPrincipalInfo)=>{
    const hasSpaceRestriction = restrictedUserPrincipalInfo?.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE) ?? false;
    const parentRestrictionCount = restrictedUserPrincipalInfo?.restrictedResources?.reduce((res, curr)=>{
        const isParentRestriction = curr?.resourceType !== (0, $1chEN.ResourceType).SPACE;
        return res + (isParentRestriction ? 1 : 0);
    }, 0) ?? 0;
    const hasParentRestriction = parentRestrictionCount > 0;
    const isBlocked = hasSpaceRestriction || hasParentRestriction;
    return {
        isBlocked: isBlocked,
        hasSpaceRestriction: hasSpaceRestriction,
        hasParentRestriction: hasParentRestriction,
        parentRestrictionCount: parentRestrictionCount
    };
};
const $1ca745aa2c0dd46c$export$89885fb2503e60cf = (requests, formatMessage, restrictedUserPrincipalInfo)=>{
    if (requests.length === 1 && restrictedUserPrincipalInfo) {
        const { hasSpaceRestriction: hasSpaceRestriction, hasParentRestriction: hasParentRestriction, parentRestrictionCount: parentRestrictionCount } = $1ca745aa2c0dd46c$export$6fedf4d3a712a334(restrictedUserPrincipalInfo);
        if (hasSpaceRestriction && hasParentRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.spaceAndParentRestriction, {
            parentRestrictionCount: parentRestrictionCount
        });
        else if (hasSpaceRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.spaceRestrictionOnly);
        else if (hasParentRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.parentRestrictionOnly, {
            parentRestrictionCount: parentRestrictionCount
        });
    }
    return null;
};
const $1ca745aa2c0dd46c$export$5afde147a40aa32c = (requests)=>{
    const avatarData = requests.flatMap((request)=>request?.user?.displayName && request?.requestAccessType && request?.user?.id ? {
            name: request.user.displayName,
            src: request.user.photos?.find((photo)=>photo?.isPrimary)?.value ?? undefined,
            key: request.user.id
        } : []);
    const maxCount = avatarData.length === 1 ? 1 : 2;
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        data: avatarData,
        maxCount: maxCount
    });
    // For single-user flags, wrap the avatar in a profile hover card trigger.
    // Multi-user flags show an avatar group — individual hover cards don't apply.
    if (requests.length === 1) {
        const onlyRequest = requests[0];
        const userId = onlyRequest?.user?.id ?? null;
        const displayName = onlyRequest?.user?.displayName ?? '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9QsA9.AccessRequestProfileCardTrigger), {
            userId: userId,
            displayName: displayName,
            offset: [
                0,
                32
            ]
        }, avatarGroup);
    }
    return avatarGroup;
};
const $1ca745aa2c0dd46c$export$8a8be71612a7c860 = (requests, restrictedUserPrincipalInfo, processRequest, onReview, onViewDetails, hideFlag, formatMessage)=>{
    if (requests.length === 1) {
        const approveRequest = ()=>{
            processRequest(requests[0], 'APPROVE', restrictedUserPrincipalInfo);
            hideFlag();
        };
        const denyRequest = ()=>{
            processRequest(requests[0], 'DENY', undefined);
            hideFlag();
        };
        const primaryAction = {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.approveButton),
            onClick: approveRequest
        };
        const secondaryAction = restrictedUserPrincipalInfo ? {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.viewDetailsButton),
            onClick: onViewDetails
        } : {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.denyButton),
            onClick: denyRequest
        };
        return [
            primaryAction,
            secondaryAction
        ];
    }
    if (requests.length > 1) return [
        {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.reviewRequestsButton),
            onClick: onReview
        }
    ];
    return [];
};
const $1ca745aa2c0dd46c$export$94e073f79b81300f = (restrictedUserPrincipalInfo, displayName, accessType, formatMessage)=>{
    const { hasSpaceRestriction: hasSpaceRestriction, hasParentRestriction: hasParentRestriction, parentRestrictionCount: parentRestrictionCount } = $1ca745aa2c0dd46c$export$6fedf4d3a712a334(restrictedUserPrincipalInfo);
    if (hasSpaceRestriction && hasParentRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successSpaceAndParentRestrictionEdit : $1ca745aa2c0dd46c$var$i18n.successSpaceAndParentRestrictionView;
        return formatMessage(messageKey, {
            displayName: displayName,
            parentRestrictionCount: parentRestrictionCount
        });
    } else if (hasSpaceRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successSpaceRestrictionOnlyEdit : $1ca745aa2c0dd46c$var$i18n.successSpaceRestrictionOnlyView;
        return formatMessage(messageKey, {
            displayName: displayName
        });
    } else if (hasParentRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successParentRestrictionOnlyEdit : $1ca745aa2c0dd46c$var$i18n.successParentRestrictionOnlyView;
        return formatMessage(messageKey, {
            displayName: displayName,
            parentRestrictionCount: parentRestrictionCount
        });
    }
    const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successNoRestrictionEdit : $1ca745aa2c0dd46c$var$i18n.successNoRestrictionView;
    return formatMessage(messageKey, {
        displayName: displayName
    });
};
const $1ca745aa2c0dd46c$export$9ffd6710da84d7ef = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onDestroy: onDestroy, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onDestroy) {
        t1 = ()=>onDestroy;
        t2 = [
            onDestroy
        ];
        $[0] = onDestroy;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return children;
};
const $1ca745aa2c0dd46c$export$6cbbb5b074df5c76 = (requests)=>requests.reduce((result, current)=>result + (current?.id ?? ''), '');








const $451ee996e81d8755$export$4e0e446ffa50ddc0 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [isActive, setIsActive] = (0, $cozmU.useState)(document?.visibilityState === "visible");
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            let timer;
            const handleVisibilityChange = ()=>{
                clearTimeout(timer);
                if (document?.visibilityState === "visible") timer = setTimeout(()=>{
                    setIsActive(true);
                }, 8000);
                else setIsActive(false);
            };
            document?.addEventListener("visibilitychange", handleVisibilityChange);
            return ()=>{
                clearTimeout(timer);
                document?.removeEventListener("visibilitychange", handleVisibilityChange);
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return isActive;
};


const $e6f9393b1f903716$var$REQUEST_ALREADY_PROCESSED = 'REQUEST_ALREADY_PROCESSED';
const $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG = 'realtime-access-request-flag';
const $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID = `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG}-id`;
const $e6f9393b1f903716$var$SPACE_COLLABORATOR_ROLE_ID = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $e6f9393b1f903716$var$SPACE_VIEWER_ROLE_ID = '26d75a6e-ad72-42c3-bf30-007d3ebae9ed';
const $e6f9393b1f903716$var$NOOP = ()=>{};
const $e6f9393b1f903716$var$i18n = (0, $kSwu1.defineMessages)({
    requestApprovedSuccess: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-approved-success",
        defaultMessage: "Request approved"
    },
    requestDeniedSuccess: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-denied-success",
        defaultMessage: "Request denied"
    },
    denialSuccessDescription: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.denial-success-description",
        defaultMessage: "{displayName}'s access to this content won't change."
    },
    requestAlreadyProcessedTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-already-processed-title",
        defaultMessage: "Someone already responded to this request"
    },
    errorResolvingRequestTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.error-resolving-request-title",
        defaultMessage: "We ran into a problem resolving the access request. Try again later."
    }
});
const $e6f9393b1f903716$var$ResolveRestrictionsDialogWrapper = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwkNQ.ResolveRestrictionsDialog), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $e6f9393b1f903716$var$UseRealtimeAccessRequestsQuery = (0, $4ea839717298c820$export$2e2bcd8739ae039);
const $e6f9393b1f903716$export$28935defd579c67a = (0, $b4dea9a5255d2c1f$export$2e2bcd8739ae039);
const $e6f9393b1f903716$var$ResolveRestrictionsMutation = (0, $927357fa0afdf6f0$export$2e2bcd8739ae039);
const $e6f9393b1f903716$export$e14a96ba31dd30b0 = (requests, userId)=>requests.filter((request)=>request?.creatorAaid !== userId);
const $e6f9393b1f903716$export$126feeec2567e438 = ({ userId: userId, cloudId: cloudId, edition: edition, contentId: contentId, contentType: contentType, pageTitle: pageTitle, flags: flags, onReviewRequests: onReviewRequests })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isRbacEnabled: isRbacEnabled, loading: rbacStatusLoading } = (0, $iquRY.useSpaceRoleMode)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const [isInitialLoad, setIsInitialLoad] = (0, $cozmU.useState)(true);
    const isTabActive = (0, $451ee996e81d8755$export$4e0e446ffa50ddc0)();
    const skipConditions = hasError || rbacStatusLoading || !isTabActive;
    const markAsErrored = (0, $cozmU.useCallback)((error)=>{
        setHasError(true);
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, []);
    const fireAnalyticEvent = (0, $cozmU.useCallback)((args)=>{
        createAnalyticsEvent({
            type: args.eventType,
            data: {
                source: args.source,
                action: args.action,
                actionSubject: args.actionSubject,
                actionSubjectId: args.actionSubjectId,
                attributes: args.attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const [mutateRequest] = (0, $308Wd.useMutationInterop)($e6f9393b1f903716$export$28935defd579c67a, {
        __callerPackage__: "share-and-restrict-dialog"
    });
    const [resolveRestrictionsForSubjects] = (0, $308Wd.useMutationInterop)($e6f9393b1f903716$var$ResolveRestrictionsMutation, {
        __callerPackage__: "share-and-restrict-dialog"
    });
    const onProcessRequestClick = (0, $cozmU.useCallback)(async (request, decision, restrictedUserPrincipalInfo)=>{
        // Purely to satisfy the linter
        if (!request || !request.id || !request.requestAccessType || !request.user || !request.user.id || !request.user.displayName || !request.creatorAaid || !request.creationDateTimestamp) return;
        const result = await mutateRequest({
            variables: {
                cloudId: cloudId,
                updateContentAccessRequestInput: {
                    contentId: contentId,
                    requestId: request.id,
                    accessType: request.requestAccessType,
                    accessRequestedAccountId: request.user.id,
                    approvalDecision: decision
                }
            }
        });
        let successfulMutation = result.data?.confluence_updateContentAccessRequest?.success;
        const requestAlreadyProcessed = result?.data?.confluence_updateContentAccessRequest?.errors?.find((err)=>err?.message === $e6f9393b1f903716$var$REQUEST_ALREADY_PROCESSED);
        // If user is blocked, run mutation to resolve restrictions
        if (successfulMutation && decision === 'APPROVE' && restrictedUserPrincipalInfo) {
            const rbacSpaceRole = request.requestAccessType === 'EDIT' ? $e6f9393b1f903716$var$SPACE_COLLABORATOR_ROLE_ID : $e6f9393b1f903716$var$SPACE_VIEWER_ROLE_ID;
            const spaceRoleId = isRbacEnabled ? rbacSpaceRole : null;
            const subjectId = request.creatorAaid;
            const subjectType = 'USER';
            const result_0 = await resolveRestrictionsForSubjects({
                variables: {
                    contentId: Number(contentId),
                    accessType: request.requestAccessType,
                    subjects: [
                        {
                            subjectId: subjectId,
                            subjectType: subjectType
                        }
                    ],
                    spaceRoleId: spaceRoleId
                }
            });
            successfulMutation = result_0?.data?.resolveRestrictionsForSubjects?.success;
        }
        if (successfulMutation) {
            flags.showSuccessFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_SUCCESS`,
                title: formatMessage(decision === 'APPROVE' ? $e6f9393b1f903716$var$i18n.requestApprovedSuccess : $e6f9393b1f903716$var$i18n.requestDeniedSuccess),
                description: decision === 'APPROVE' ? (0, $1ca745aa2c0dd46c$export$94e073f79b81300f)(restrictedUserPrincipalInfo, request.user.displayName, request.requestAccessType, formatMessage) : formatMessage($e6f9393b1f903716$var$i18n.denialSuccessDescription, {
                    displayName: request.user.displayName
                }),
                isAutoDismiss: true
            });
            if (decision === 'APPROVE') fireAnalyticEvent({
                eventType: 'sendTrackEvent',
                action: 'granted',
                actionSubject: 'access',
                actionSubjectId: 'grantAccess',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    accessType: request.requestAccessType,
                    processingTime: Date.now() - request.creationDateTimestamp,
                    creationDateTimestamp: request.creationDateTimestamp,
                    ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo)
                }
            });
            else fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'denyAccess',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    accessType: request.requestAccessType,
                    processingTime: Date.now() - request.creationDateTimestamp,
                    creationDateTimestamp: request.creationDateTimestamp,
                    ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo)
                }
            });
        } else if (requestAlreadyProcessed) {
            flags.showInfoFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_INFO`,
                title: formatMessage($e6f9393b1f903716$var$i18n.requestAlreadyProcessedTitle),
                isAutoDismiss: true
            });
            fireAnalyticEvent({
                eventType: 'sendTrackEvent',
                action: 'alreadyProcessed',
                actionSubject: 'accessRequestsRealtimeFlagMutation',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    attemptedDecision: decision,
                    accessType: request.requestAccessType,
                    ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo)
                }
            });
        } else {
            flags.showErrorFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_ERROR`,
                title: formatMessage($e6f9393b1f903716$var$i18n.errorResolvingRequestTitle),
                isAutoDismiss: true
            });
            const err_0 = result?.data?.confluence_updateContentAccessRequest?.errors?.[0];
            const message = err_0?.message || 'unknown';
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'failed',
                actionSubject: 'accessRequestsRealtimeFlagMutation',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    requestId: request.id,
                    contentId: contentId,
                    accessType: request.requestAccessType,
                    accountId: request.creatorAaid,
                    message: message
                }
            });
        }
    }, [
        cloudId,
        contentId,
        isRbacEnabled,
        flags,
        mutateRequest,
        resolveRestrictionsForSubjects,
        formatMessage,
        fireAnalyticEvent
    ]);
    const maybeShowRealtimeFlag = (0, $cozmU.useCallback)(async (data, eventName)=>{
        // This is only used for analytics
        const queryTrigger = eventName ?? (isInitialLoad ? 'initialLoad' : 'tabVisible');
        if (isInitialLoad) setIsInitialLoad(false);
        const accessRequests = $e6f9393b1f903716$export$e14a96ba31dd30b0(data.confluence_getLatestPendingRequests?.latestPendingRequest ?? [], userId);
        (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).updateIndicatorVisibility(contentId, accessRequests[0]?.creationDateTimestamp ?? 0, eventName === 'contentAccessRequested' ? 'partial' : 'full', accessRequests?.length ?? 0);
        if (accessRequests.length === 0) {
            // If a cached "last seen" timestamp for a realtime flag exists and it's > 5 minutes old
            // Then we can clear the cache to avoid buildup
            (0, $ba14d5ed8e7789e1$export$37d57e4c435593ab)(contentId);
            return;
        }
        // We just need to remove requests older than the "last seen" one in the cache
        // Also ensure all requests have bare minimum info to display flag correctly
        const filteredRequests = accessRequests.filter((request_0)=>{
            const hasAllNecessaryData = request_0?.user?.displayName && request_0?.requestAccessType;
            const requestCreationTimestamp = Number(request_0?.creationDateTimestamp);
            const isMoreRecentThanLastSeenRequest = (0, $ba14d5ed8e7789e1$export$8d67ec31af2e3b08)(contentId, requestCreationTimestamp);
            return hasAllNecessaryData && isMoreRecentThanLastSeenRequest;
        });
        const latestIncomingRequestCreatedAt = Number(filteredRequests[0]?.creationDateTimestamp);
        if (filteredRequests.length === 0) return;
        // ID of any realtime flag that might be currently displayed
        const EXISTING_FLAG_ID = flags.state.flags.find(({ id: id })=>id.toString().startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG))?.id;
        // ID of the flag that we're about to display.
        // The suffix is a concatenated list of all the request ID-s displayed in the flag.
        // It helps us to know if the existing and new flag are going to be the same. See the edge case below
        const NEXT_FLAG_ID = `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_${(0, $1ca745aa2c0dd46c$export$6cbbb5b074df5c76)(filteredRequests)}`;
        /**
     * EDGE CASE: Flag gets hidden and exact same flag gets shown in its place.
     * This can happen because of tab inactivity monitoring. To reproduce:
     *
     * 1. Existing Realtime flag is showing on a page
     * 2. You click away into another tab.
     * 3. Click back on the original tab with the Realtime flag wihin 16s (autodismiss timeout)
     *    - we refetch all requests because the tab is now active again
     *    - the new request(s) are very likely the same as the ones already displayed in the flag
     *    - The existing flag gets hidden and a new flag with the same request(s) gets shown
     *    - To prevent this we just return early in this case
     *
     * This is likely to happen often as people click back and forth between tabs, so better to address it
     */ if (EXISTING_FLAG_ID === NEXT_FLAG_ID) return;
        /**
     * We cache the request as "seen" when the flag for it gets destroyed
     * However, if another realtime flag was shown WHILE the the current requests's flag is visible
     * Then we don't want to cache the current request to allow the current request to continue
     * showing in the newer flags' stacked display.
     *
     * As a reminder, requirements state that if a current flag is displayed and a new request comes in,
     * then the current flag needs to be replaced by a new flag that shows both of the requests with a facepile
     * for both users.
     *
     * If a third request comes in, then that second flag will get replaced with a third one, with the facepile
     * now showing 3 users, etc.
     *
     * Thus, to allow for this stacking of requests to occur, we only want to cache the last seen request when
     * the last flag in this request overlap sequence gets destroyed.
     * */ const onDestroy = ()=>{
            const skipCachingOfLastSeenFlag = flags.state.flags.find(({ id: id_0 })=>`${id_0}`.startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG) && id_0 !== NEXT_FLAG_ID);
            if (!skipCachingOfLastSeenFlag) (0, $ba14d5ed8e7789e1$export$289c54b917400e1c)(contentId, latestIncomingRequestCreatedAt);
        };
        let restrictedUserPrincipalInfo_0;
        let resolveRestrictionsDialogProps;
        let onViewDetailsClick = $e6f9393b1f903716$var$NOOP;
        const hideFlag = ()=>{
            flags.hideFlag(NEXT_FLAG_ID);
        };
        const onReviewRequestsClick = ()=>{
            onReviewRequests();
            hideFlag();
            fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'reviewRequests',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    trigger: queryTrigger,
                    requestsDisplayed: filteredRequests.length
                }
            });
        };
        if (filteredRequests.length === 1) {
            const request_1 = filteredRequests[0];
            const user = request_1?.user;
            const accessType = request_1?.requestAccessType ?? 'VIEW';
            const addMode = accessType === 'EDIT' ? 'as-editor' : 'as-viewer';
            const userPrincipal = {
                id: user?.id ?? '',
                name: user?.displayName ?? '',
                avatarUrl: user?.photos?.find((photo)=>photo?.isPrimary)?.value ?? '',
                email: '',
                // not needed
                knownErrors: undefined,
                sitePermissionType: accessType
            };
            // Make the blocked access check
            const [{ showResolveRestrictionsDialog: showResolveRestrictionsDialog, showWarnRestrictionsDialog: showWarnRestrictionsDialog, restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection }] = await Promise.all([
                (0, $7QoAs.validateRestrictedPrincipals)({
                    contentId: contentId,
                    cloudId: cloudId,
                    edition: edition,
                    numberOfAncestors: 1,
                    addMode: // not needed, API will error out if < 10 layers of ancestors
                    addMode,
                    stagedUserPrincipals: [
                        userPrincipal
                    ],
                    setMasterState: ()=>{},
                    fireAnalyticEvent: // not needed
                    fireAnalyticEvent
                }),
                (0, $f2UnK.preloadSpaceRoleMode)(cloudId)
            ]);
            /** Early return if user is not empowered to resolve blocked access */ if (showWarnRestrictionsDialog) {
                fireAnalyticEvent({
                    eventType: 'sendUIEvent',
                    action: 'aborted',
                    actionSubject: 'realtimeFlag',
                    source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                    attributes: {
                        trigger: queryTrigger,
                        requestsDisplayed: filteredRequests.length,
                        ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0)
                    }
                });
                return;
            }
            if (showResolveRestrictionsDialog && restrictedUserPrincipals?.[0]) {
                restrictedUserPrincipalInfo_0 = restrictedUserPrincipals?.[0];
                onViewDetailsClick = ()=>{
                    showModal($e6f9393b1f903716$var$ResolveRestrictionsDialogWrapper, resolveRestrictionsDialogProps);
                    hideFlag();
                    fireAnalyticEvent({
                        eventType: 'sendUIEvent',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'viewDetails',
                        source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                        attributes: {
                            trigger: queryTrigger,
                            requestsDisplayed: filteredRequests.length,
                            ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0)
                        }
                    });
                };
                const approveRequest = ()=>{
                    onProcessRequestClick(request_1, 'APPROVE', restrictedUserPrincipalInfo_0);
                    hideFlag();
                };
                resolveRestrictionsDialogProps = {
                    contentId: contentId,
                    restrictedUserPrincipals: restrictedUserPrincipals,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection,
                    pageTitle: pageTitle,
                    addMode: addMode,
                    onComplete: approveRequest,
                    onClose: $e6f9393b1f903716$var$NOOP,
                    onCloseComplete: $e6f9393b1f903716$var$NOOP,
                    onSkip: $e6f9393b1f903716$var$NOOP,
                    showErrorFlag: flags.showErrorFlag,
                    triggeredBy: 'realtimeAccessRequestFlag'
                };
            }
        }
        const onFlagCloseButtonClick = ()=>{
            fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissRealtimeAccessRequestFlag',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    trigger: queryTrigger,
                    requestsDisplayed: filteredRequests.length,
                    ...filteredRequests.length === 1 ? (0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0) : {}
                }
            });
        };
        await flags.showCustomFlag({
            id: NEXT_FLAG_ID,
            isAutoDismiss: true,
            autoDismissSeconds: 16,
            customIcon: (0, $1ca745aa2c0dd46c$export$5afde147a40aa32c)(filteredRequests),
            onClose: onFlagCloseButtonClick,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ca745aa2c0dd46c$export$9ffd6710da84d7ef), {
                onDestroy: onDestroy
            }, (0, $1ca745aa2c0dd46c$export$9ddb107f546f744e)(filteredRequests, formatMessage)),
            description: (0, $1ca745aa2c0dd46c$export$89885fb2503e60cf)(filteredRequests, formatMessage, restrictedUserPrincipalInfo_0),
            actions: (0, $1ca745aa2c0dd46c$export$8a8be71612a7c860)(filteredRequests, restrictedUserPrincipalInfo_0, onProcessRequestClick, // Approves / Denies request based on arguments
            onReviewRequestsClick, // Opens USD -> Access Requests
            onViewDetailsClick, // Opens standalone version of Resolve Restrictions Modal
            hideFlag, formatMessage)
        });
        /**
     * Fire flag shown analytic
     */ fireAnalyticEvent({
            eventType: 'sendUIEvent',
            action: 'shown',
            actionSubject: 'realtimeFlag',
            source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
            attributes: {
                trigger: queryTrigger,
                requestsDisplayed: filteredRequests.length,
                ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0)
            }
        });
        /**
     * Only hide any existing flags AFTER the latest flag has been shown
     * This ensures that the onDestroy callback of the existing flag
     * Will realize there's a newer flag on the screen
     * And will thus skip caching the EXISTING_FLAG_ID's request as seen
     * This allows the request to coninue appearing in the facepile of any
     * Newer flags that are displayed after it
     */ if (EXISTING_FLAG_ID) await flags.hideFlag(EXISTING_FLAG_ID);
    }, [
        userId,
        cloudId,
        contentId,
        pageTitle,
        edition,
        onProcessRequestClick,
        onReviewRequests,
        fireAnalyticEvent,
        flags,
        showModal,
        formatMessage,
        isInitialLoad
    ]);
    const { refetch: refetch, error: error_0 } = (0, $jMyy4.useQueryInterop)($e6f9393b1f903716$var$UseRealtimeAccessRequestsQuery, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            duration: (0, $ba14d5ed8e7789e1$export$7e0819e7cb643ce3)
        },
        skip: skipConditions,
        fetchPolicy: 'network-only',
        // This "onCompleted" runs only on initial load.
        onCompleted: maybeShowRealtimeFlag,
        onError: markAsErrored,
        __callerPackage__: "share-and-restrict-dialog"
    });
    if (error_0) {
        (0, $7Sm4c.markErrorAsHandled)(error_0);
        if (hasError === false) setHasError(true);
    }
    const onDataReceived = (0, $cozmU.useCallback)(async (eventName_0)=>{
        try {
            /**
       * Decide how far back in time we look to find existing pending requests.
       *
       * Option 1: eventName === 'contentAccessDecisionMade'
       * If it's after an existing request was just approved / denied, we want ALL requests
       * If no requests come back in response to that, then we can remove the 🔵 indicator
       *
       * Option 2: eventName === 'contentAccessRequested'
       * If it's after a new access request was just created, we only want to fetch the last
       * 5 minutes (or whatever short period we decide). This allows us to show a realtime flag
       * only for newly created requests that haven't been seen yet.
       * We cache the last seen realtime request creation date in localStorage.
       */ const lookbackPeriod = eventName_0 === 'contentAccessDecisionMade' ? (0, $ba14d5ed8e7789e1$export$7e0819e7cb643ce3) : (0, $ba14d5ed8e7789e1$export$c47be26a650fe21);
            const result_1 = await refetch({
                duration: lookbackPeriod,
                cloudId: cloudId,
                contentId: contentId
            });
            await maybeShowRealtimeFlag(result_1.data, eventName_0);
        } catch (e) {
            markAsErrored(e);
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'failed',
                actionSubject: 'onDataReceived',
                actionSubjectId: eventName_0,
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    name: e?.name,
                    message: e?.message
                }
            });
        }
    }, [
        refetch,
        cloudId,
        contentId,
        markAsErrored,
        maybeShowRealtimeFlag,
        fireAnalyticEvent
    ]);
    // Monitor when new pending requests get created
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'contentAccessRequested',
        subscriberId: (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        onDataReceived: onDataReceived,
        skip: skipConditions
    });
    // Monitor the approval / denial of existing pending requests
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'contentAccessDecisionMade',
        subscriberId: (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        onDataReceived: onDataReceived,
        skip: skipConditions
    });
    // Cleanup effect when page is navigated away from
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Subscribers need to be reset when the hook gets killed
            // This usually means that the share button got dismounted
            // And user navigated away from the current content
            (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).resetSubscribers();
            // Databases and Whiteboards DON'T hide the flags when leaving the content
            // Live pages, regular pages DO hide the flags when leaving the content
            // Thus we choose to hide the flags everywhere to equalize behavior
            const existingFlagId = flags.state.flags.find(({ id: id_1 })=>id_1.toString().startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG))?.id;
            if (existingFlagId) flags.hideFlag(existingFlagId);
        };
    }, [
        flags
    ]);
};


const $b7b8f942bb046fc6$var$RealtimeAccessRequestsInternal = (0, $7aRa9.withFlags)(({ cloudId: cloudId, userId: userId, edition: edition, contentType: contentType, contentId: contentId, pageTitle: pageTitle, flags: flags, onReviewRequestsClick: onReviewRequests })=>{
    (0, $e6f9393b1f903716$export$126feeec2567e438)({
        userId: userId,
        cloudId: cloudId,
        edition: edition,
        onReviewRequests: onReviewRequests,
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        flags: flags
    });
    return null;
});
const $b7b8f942bb046fc6$export$c85837ac639c35b3 = (accessStatus)=>[
        null,
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS,
        (0, $d9tcB.AccessStatus).NOT_PERMITTED,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS
    ].includes(accessStatus);
const $b7b8f942bb046fc6$export$6e9d9c4509b6c805 = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { cloudId: cloudId, userId: userId, edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isSSR = (0, $e4o8D.useRenderServerPlaceholder)();
    if (isSSR || !cloudId || !userId || !edition || edition === "FREE" || !isLoggedIn || $b7b8f942bb046fc6$export$c85837ac639c35b3(accessStatus)) return null;
    let t0;
    if ($[0] !== cloudId || $[1] !== edition || $[2] !== props || $[3] !== userId) {
        t0 = (0, $6mKj3.expValEquals)("cc_fe_realtime_access_requests", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7b8f942bb046fc6$var$RealtimeAccessRequestsInternal, {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            ...props
        }) : null;
        $[0] = cloudId;
        $[1] = edition;
        $[2] = props;
        $[3] = userId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $b7b8f942bb046fc6$export$6ad2e2265e081d0a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($b7b8f942bb046fc6$export$6e9d9c4509b6c805);



var $Qy97i = parcelRequire("Qy97i");


var $fdPUP = parcelRequire("fdPUP");





var $i3jcY = parcelRequire("i3jcY");


var $ePExc = parcelRequire("ePExc");


var $38Ncj = parcelRequire("38Ncj");

























const $6663c77035b2c619$var$useShareAndRestrictButtonDataQuery = (0, $38Ncj.default);
const $6663c77035b2c619$var$tooltipMessages = (0, $kSwu1.defineMessages)({
    restricted: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.restricted",
        defaultMessage: "Restricted - Only specific people can access"
    },
    inherited: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.inherited",
        defaultMessage: "Restricted by a parent - Anyone on the parent item can access"
    },
    draft: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.draft",
        defaultMessage: "Open - Anyone in the space (with the link) can access"
    },
    openEdit: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.openEdit",
        defaultMessage: "Open - Anyone in the space can edit"
    },
    openView: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.openView",
        defaultMessage: "Open - Anyone in the space can view"
    },
    public: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.public",
        defaultMessage: "Public - Anyone with the link can access"
    },
    error: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.error",
        defaultMessage: "Access level failed to load"
    },
    accessLinkEnabled: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.access-link-enabled",
        defaultMessage: "Confluence access link is on"
    },
    publicAccessLinkEnabled: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.public-access-link-enabled",
        defaultMessage: "Public access link is on"
    }
});
const $6663c77035b2c619$var$getIconAndTooltipFromData = (isPublicLinkOn, hasInheritedRestrictions, hasViewRestrictions, isErrored, isUnpublishedDraft, hasRestrictions, isAccessLinkOn, accessType)=>{
    if (isErrored) return [
        'error',
        $6663c77035b2c619$var$tooltipMessages.error
    ];
    if (isAccessLinkOn) return [
        'internal',
        $6663c77035b2c619$var$tooltipMessages.accessLinkEnabled
    ];
    if (isPublicLinkOn) {
        if (accessType === 'EXTERNAL') return [
            'public',
            $6663c77035b2c619$var$tooltipMessages.publicAccessLinkEnabled
        ];
        return [
            'public',
            $6663c77035b2c619$var$tooltipMessages.public
        ];
    }
    if (hasViewRestrictions) return [
        'restricted',
        $6663c77035b2c619$var$tooltipMessages.restricted
    ];
    if (hasInheritedRestrictions) return [
        'restricted',
        $6663c77035b2c619$var$tooltipMessages.inherited
    ];
    if (isUnpublishedDraft) return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.draft
    ];
    if (hasRestrictions) return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.openView
    ];
    return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.openEdit
    ];
};
const $6663c77035b2c619$var$EXPECTED_FREE_EDITION_PUBLIC_LINK_ERROR = 'This is a Standard/Premium feature. You are currently subscribed to the Free plan.';
const $6663c77035b2c619$export$9a3aafa686359f8d = (contentId, isContentTypePublicLinkEligible, isUnpublishedDraft, contentType)=>{
    const shouldIncludePublicLink = isContentTypePublicLinkEligible && (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? true : isContentTypePublicLinkEligible;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($6663c77035b2c619$var$useShareAndRestrictButtonDataQuery, {
        variables: {
            contentId: contentId,
            isContentTypePublicLinkEligible: shouldIncludePublicLink
        },
        fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? 'cache-and-network' : 'network-only',
        errorPolicy: 'all',
        __callerPackage__: "share-and-restrict-dialog"
    });
    const errors = [];
    if (error?.message.includes($6663c77035b2c619$var$EXPECTED_FREE_EDITION_PUBLIC_LINK_ERROR)) (0, $7Sm4c.markErrorAsHandled)(error);
    else if (error) errors.push(error);
    const hasRestrictions = Boolean(data?.singleContent?.hasRestrictions);
    const hasInheritedRestrictions = Boolean(data?.singleContent?.hasInheritedRestrictions);
    const hasViewRestrictions = Boolean(data?.singleContent?.hasViewRestrictions);
    const pageTitle = data?.singleContent?.title;
    const isPublicLinkOn = shouldIncludePublicLink ? data?.publicLinkPage?.pageStatus === 'ON' : false;
    const accessType = data?.publicLinkPage?.accessType ?? null;
    const isAccessLinkOn = (0, $fdPUP.ACCESS_LINK_ENROLLED_CONTENT_TYPES).includes(contentType) && !isUnpublishedDraft && accessType === 'INTERNAL_LICENSED' && data?.publicLinkPage?.pageStatus === 'ON' && (0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true);
    const [icon, tooltipMessage] = $6663c77035b2c619$var$getIconAndTooltipFromData(isPublicLinkOn, hasInheritedRestrictions, hasViewRestrictions, Boolean(errors.length), isUnpublishedDraft, hasRestrictions, isAccessLinkOn, accessType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'shareAndRestrictButtonQuery',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    return {
        icon: icon,
        tooltipMessage: tooltipMessage,
        refetch: ()=>{
            refetch?.({
                contentId: contentId,
                isContentTypePublicLinkEligible: shouldIncludePublicLink
            });
        },
        // When navigating in SPA, the cache-and-network fetchPolicy will initially return the data
        // from the previous page if the current one has not been visited before. This check ensures
        // that we show the loading state when the data for this content is not actually available.
        isLoading: loading && !Boolean(data?.singleContent?.id === contentId),
        error: errors.length > 0 ? errors[0] : null,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        isPublicLinkOn: isPublicLinkOn,
        pageTitle: pageTitle,
        isUnpublishedDraft: isUnpublishedDraft,
        accessType: accessType
    };
};



var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $0e2cc7602bd622b9$var$initialState = {
    hasClickedShareButton: false
};
const $0e2cc7602bd622b9$var$actions = {
    setHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: true
            });
        },
    resetHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: false
            });
        }
};
const $0e2cc7602bd622b9$var$ShareAndRestrictButtonStore = (0, $8s9DV.createStore)({
    initialState: $0e2cc7602bd622b9$var$initialState,
    actions: $0e2cc7602bd622b9$var$actions,
    name: 'ShareAndRestrictButtonStore'
});
const $0e2cc7602bd622b9$export$15991ed5dace2362 = (0, $kBr4q.createStateHook)($0e2cc7602bd622b9$var$ShareAndRestrictButtonStore);
const $0e2cc7602bd622b9$export$6033af6626ad7b59 = (0, $kBr4q.createActionsHook)($0e2cc7602bd622b9$var$ShareAndRestrictButtonStore);









var $gqypm = parcelRequire("gqypm");

const $bcc2dd382176fa47$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
//THE GA Date of USD, any users onboarding on or after this date are considered new users
const $bcc2dd382176fa47$var$NEW_USER_FROM_DATE = new Date('2025-03-24');
const $bcc2dd382176fa47$export$750d18e9348a361a = ()=>{
    const $ = (0, $bDgLe.c)(14);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const t0 = userId ?? "";
    let t1;
    if ($[0] !== cloudId || $[1] !== t0) {
        t1 = {
            cloudId: cloudId,
            userId: t0
        };
        $[0] = cloudId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !userId || !cloudId;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data, loading: loading, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)(t3);
    if (loading || error) {
        let t4;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                isNewUser: true
            };
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    let firstActiveDate;
    let t4;
    let t5;
    if ($[7] !== attributes) {
        const firstActiveValue = attributes?.find($bcc2dd382176fa47$var$_temp)?.value;
        firstActiveDate = new Date(firstActiveValue ?? "");
        t4 = isNaN;
        t5 = firstActiveDate.getTime();
        $[7] = attributes;
        $[8] = firstActiveDate;
        $[9] = t4;
        $[10] = t5;
    } else {
        firstActiveDate = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    const isValidDate = !t4(t5);
    if (!isValidDate) {
        let t6;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                isNewUser: true
            };
            $[11] = t6;
        } else t6 = $[11];
        return t6;
    }
    const t6 = Boolean(firstActiveDate >= $bcc2dd382176fa47$var$NEW_USER_FROM_DATE);
    let t7;
    if ($[12] !== t6) {
        t7 = {
            isNewUser: t6
        };
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
function $bcc2dd382176fa47$var$_temp(t0) {
    const { name: name } = t0;
    return name === $bcc2dd382176fa47$var$CONFLUENCE_FIRST_ACTIVE_TRAIT;
}



var $lT8a1 = parcelRequire("lT8a1");


var $grWYF = parcelRequire("grWYF");

const $d1b365751f35aaca$var$PUBLIC_LINK_ENROLLED_CONTENT_TYPES = [
    'page',
    'whiteboard'
];
const $d1b365751f35aaca$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    shareButtonSpotlightHeading: {
        id: "share-and-restrict-dialog.spotlight.heading",
        defaultMessage: "Restrictions have moved"
    },
    shareButtonSpotlightText: {
        id: "share-and-restrict-dialog.spotlight.text",
        defaultMessage: "Now you can share and restrict access to your content in one place."
    },
    shareButtonSpotlightLearnMore: {
        id: "share-and-restrict-dialog.spotlight.learn-more",
        defaultMessage: "Learn more"
    },
    shareButtonSpotlightOk: {
        id: "share-and-restrict-dialog.spotlight.ok",
        defaultMessage: "OK"
    },
    shareButtonChangeBoardingFlagHeading: {
        id: "share-and-restrict-dialog.flag.heading",
        defaultMessage: "Your lock icon has moved"
    },
    shareButtonChangeBoardingFlagDescription: {
        id: "share-and-restrict-dialog.flag.message",
        defaultMessage: "The lock icon (where you manage access to your content) is now in the Share button."
    },
    shareButtonChangeBoardingFlagAction: {
        id: "share-and-restrict-dialog.flag.action",
        defaultMessage: "Show me"
    }
});
const $d1b365751f35aaca$var$useRedirectedFromRestrictQueryParam = (0, $dPJCf.createSingleQueryParamHook)('redirectedFromRestrict');
const $d1b365751f35aaca$var$convertPageMode = (mode)=>mode === (0, $cD1qu.PageMode).LIVE ? (0, $cD1qu.PageMode).VIEW : mode;
const $d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID = 'share-restrict-button-changeboarding-flag';
const $d1b365751f35aaca$var$ShareRestrictAndCopyCoordinatorComponent = ({ contentId: contentId, shareeAction: shareeAction = 'view', allowRestrictions: allowRestrictions = true, contentType: contentType, contentSubType: contentSubType, isUnpublishedDraft: isUnpublishedDraft = false, isNotifyDisabled: isNotifyDisabled = false, isApprovalHandoffEnabled: isApprovalHandoffEnabled = false, onSuccessfulShareWithApprovalIntent: onSuccessfulShareWithApprovalIntent, flags: flags, isShareAndRestrictButtonDisabled: // Separate disabled states
isShareAndRestrictButtonDisabled = false, isCopyLinkButtonDisabled: isCopyLinkButtonDisabled = false, // CopyLinkButton props
...copyLinkButtonProps })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [controllerMounted, setControllerMounted] = (0, $cozmU.useState)(false);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    // Grant Access query params
    const isRedirectedFromRestrict = $d1b365751f35aaca$var$useRedirectedFromRestrictQueryParam();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    // Hook to store share button click state
    const { setHasClickedShareButton: setHasClickedShareButton, resetHasClickedShareButton: resetHasClickedShareButton } = (0, $0e2cc7602bd622b9$export$6033af6626ad7b59)();
    // Create a ref for the share button
    const shareButtonRef = (0, $cozmU.useRef)(null);
    const isContentTypePublicLinkEligible = $d1b365751f35aaca$var$PUBLIC_LINK_ENROLLED_CONTENT_TYPES.includes(contentType);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const { icon: // Used here for rendering the button
    icon, isLoading: isLoading, error: error, tooltipMessage: tooltipMessage, refetch: refetch, hasInheritedRestrictions: // Used here for analytics
    hasInheritedRestrictions, hasRestrictions: hasRestrictions, hasViewRestrictions: hasViewRestrictions, isPublicLinkOn: isPublicLinkOn, pageTitle: pageTitle } = (0, $6663c77035b2c619$export$9a3aafa686359f8d)(contentId, isContentTypePublicLinkEligible, isUnpublishedDraft, contentType);
    const { isNewUser: isNewUser } = (0, $bcc2dd382176fa47$export$750d18e9348a361a)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (renderServerPlaceholder) return;
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    actionSubject: 'button',
                    actionSubjectId: 'ShareAndRestrictButton',
                    action: 'clicked',
                    attributes: {
                        contentId: contentId,
                        contentSubType: contentSubType,
                        isLivePage: contentSubType === 'live',
                        isDraft: isUnpublishedDraft,
                        contentType: contentType,
                        edition: edition,
                        hasInheritedRestrictions: hasInheritedRestrictions,
                        hasRestrictions: hasRestrictions,
                        hasViewRestrictions: hasViewRestrictions,
                        isPublicLinkOn: isPublicLinkOn,
                        pageMode: shareeAction
                    }
                }
            }).fire();
            refetch();
            setControllerMounted(true);
            //mark has share button click to true
            setHasClickedShareButton();
            //start share and restrict dialog load experience
            experienceTracker.start({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
                attributes: {
                    ...(0, $3jRrs.getIsInConfluenceHoldoutData)()
                }
            });
        }
    }, [
        createAnalyticsEvent,
        contentId,
        contentSubType,
        contentType,
        edition,
        hasInheritedRestrictions,
        hasRestrictions,
        hasViewRestrictions,
        isUnpublishedDraft,
        isPublicLinkOn,
        refetch,
        shareeAction,
        experienceTracker,
        renderServerPlaceholder,
        setHasClickedShareButton
    ]);
    (0, $cozmU.useEffect)(()=>{
        resetHasClickedShareButton();
    }, [
        resetHasClickedShareButton
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'ShareAndRestrictButton',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    isLivePage: contentSubType === 'live',
                    isDraft: isUnpublishedDraft,
                    pageMode: shareeAction
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType,
        contentSubType,
        isUnpublishedDraft,
        shareeAction
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isLoading && !error) experienceTracker.succeed({
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
        else if (!isLoading && error) experienceTracker.fail({
            error: error,
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
    }, [
        error,
        isLoading,
        experienceTracker
    ]);
    const { data: data, loading: loading, error: spotlightError } = (0, $ivb8S.useGetOnboardingState)((0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $cozmU.useEffect)(()=>{
        if (data && !loading && !spotlightError && !error) {
            const spotlightSeen = data?.onboardingState?.find((prop)=>prop.key === (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN)?.value === 'true';
            // Live pages does not want users to see USD button change-boarding
            if (!(contentSubType == 'live' || isNewUser)) // If the spotlight hasn't been seen before
            {
                if (!spotlightSeen) {
                    const markSpotlightAsSeen = ()=>setOnboardingState({
                            key: (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN,
                            value: 'true'
                        });
                    const onFlagDismissClick = ()=>{
                        markSpotlightAsSeen();
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'flag dismissed',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                    };
                    const onFlagShowMeClick = ()=>{
                        setIsSpotlightActive(true);
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'spotlight shown',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                        flags.hideFlag($d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID);
                        markSpotlightAsSeen();
                    };
                    const showFlag = async ()=>{
                        await flags.showFlag({
                            id: $d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID,
                            type: 'custom',
                            title: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagHeading),
                            description: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagDescription),
                            actions: [
                                {
                                    content: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagAction),
                                    onClick: onFlagShowMeClick
                                }
                            ],
                            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3cW6b))), {
                                label: ""
                            }),
                            onClose: onFlagDismissClick,
                            close: 'auto'
                        });
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'flag shown',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                    };
                    // Suppress changeboarding flag during E2E/VR tests to avoid flaky screenshots
                    if (!(0, $i3jcY.isStableUIEnabledForTests)()) showFlag();
                }
            }
        } else if (spotlightError && !loading) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: 'ShareAndRestrictButton',
                action: 'spotlight failed',
                attributes: {
                    contentId: contentId,
                    contentSubType: contentSubType,
                    isLivePage: contentSubType === 'live',
                    contentType: contentType,
                    edition: edition,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    hasRestrictions: hasRestrictions,
                    hasViewRestrictions: hasViewRestrictions,
                    isPublicLinkOn: isPublicLinkOn,
                    pageMode: shareeAction
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        loading,
        spotlightError,
        error
    ]);
    const endSpotlight = ()=>{
        // Change spotlight state to only show once
        setOnboardingState({
            key: (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN,
            value: 'true'
        });
        setIsSpotlightActive(false);
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const learnMoreClicked = ()=>{
        endSpotlight();
        window.open((0, $fdPUP.SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION), '_blank', 'noreferrer');
    };
    const renderControlledShareButton = ()=>{
        const indicatorRightOffset = icon === 'public' || icon === 'internal' ? 54 : 55;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d35qt.NewAccessRequestIndicator), {
            top: 4,
            right: indicatorRightOffset,
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Qy97i.ControlledShareButton), {
            tooltipMessage: tooltipMessage,
            icon: icon,
            onClick: handleClick,
            isDisabled: isShareAndRestrictButtonDisabled || isNetworkDisabled,
            focusRef: shareButtonRef
        }));
    };
    const origPageMode = (0, $aSsfA.useGetPageMode)();
    const pageMode = $d1b365751f35aaca$var$convertPageMode(origPageMode);
    const spaceKey = (0, $cLo2u.useSpaceKey)() ?? '';
    const { shouldShowGrantAccess: shouldShowGrantAccess, clearGrantAccessQueryParams: clearGrantAccessQueryParams } = (0, $913c9f7b92c5afc8$export$2914b3c0c287db)();
    const [initialDialog, setInitialDialog] = (0, $cozmU.useState)(shouldShowGrantAccess && edition !== 'FREE' ? 'accessRequests' : undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (initialDialog) setControllerMounted(true);
    }, [
        initialDialog
    ]);
    const openAccessRequestsDialog = (0, $cozmU.useCallback)(()=>{
        setInitialDialog('accessRequests');
    }, []);
    const clearInitialDialog = (0, $cozmU.useCallback)(()=>{
        setInitialDialog(undefined);
        clearGrantAccessQueryParams();
    }, [
        clearGrantAccessQueryParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "share-button",
        enabled: origPageMode !== (0, $cD1qu.PageMode).VIEW && // cc_editor_two_stage_hydration_removal - When cleaning up this experiment, also remove the related TwoStageHydration component
        !(0, $6mKj3.expValEquals)('cc_editor_two_stage_hydration_removal', 'shareAndRestrictButton', true),
        ssrPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "share-restrict-and-copy-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: "shareAndRestrictButton"
    }, isRedirectedFromRestrict && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6DT7W.RequestAccessPopupComponent), {
        contentId: contentId
    }), renderControlledShareButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
        actions: [
            {
                onClick: endSpotlight,
                text: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightOk)
            },
            {
                onClick: learnMoreClicked,
                text: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightLearnMore)
            }
        ],
        heading: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightHeading),
        target: "shareAndRestrictButton",
        key: "shareAndRestrict-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "bottom right",
        dialogWidth: 275
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        values: {
            bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        },
        ...$d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightText
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $grWYF.OnboardingPagePermissionsSpotlightLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.SHARE_PAGE_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_SHARE_PAGE_SHORTCUT),
        listener: handleClick
    })), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
        key: contentId,
        customData: {
            shareButtonType: 'ShareAndRestrictButton'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkzol.CopyLinkButton), {
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        isDisabled: isCopyLinkButtonDisabled,
        ...copyLinkButtonProps
    }))), controllerMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ePExc.ShareAndRestrictDialogController), {
        isExternalCollaborator: isExternalCollaborator,
        contentId: contentId,
        contentType: contentType,
        contentSubType: contentSubType,
        allowRestrictions: allowRestrictions,
        pageTitle: pageTitle,
        pageMode: shareeAction,
        refetchButtonData: refetch,
        onClose: ()=>{
            setControllerMounted(false);
        },
        isUnpublishedDraft: isUnpublishedDraft,
        isNotifyDisabled: isNotifyDisabled,
        focusRef: shareButtonRef,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        isSuperAdmin: isSuperAdmin,
        initialDialog: initialDialog,
        isApprovalHandoffEnabled: isApprovalHandoffEnabled,
        onSuccessfulShareWithApprovalIntent: onSuccessfulShareWithApprovalIntent,
        onInitialDialogOpen: clearInitialDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7b8f942bb046fc6$export$6ad2e2265e081d0a), {
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        onReviewRequestsClick: openAccessRequestsDialog
    }));
};
const $d1b365751f35aaca$export$d9b7b2c2d990f8ed = (0, $7aRa9.withFlags)($d1b365751f35aaca$var$ShareRestrictAndCopyCoordinatorComponent);


const $67cd68d5c5612721$export$5894b1d1838f517c = (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props.contentId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
            isCustomStart: true,
            key: props.contentId
        });
        $[0] = props.contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d1b365751f35aaca$export$d9b7b2c2d990f8ed), props);
        $[3] = props;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t0 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, t1, t2);
        $[5] = t0;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ShareAndRestrictButton"] = $67cd68d5c5612721$export$5894b1d1838f517c;

});

parcelRegister("d35qt", function(module, exports) {
/* NewAccessRequestIndicator.tsx generated by @compiled/babel-plugin v0.40.0 */ /**
 * Yes, this file is one giant exception to the rules, it is intentional.
 * If we were to do this with Javascript it would be way less performant
 * And more error prone
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $eRpR8 = parcelRequire("eRpR8");

const $ad45489d485fda80$var$styles = {
    accessRequestsStatusContainer: "_kqswh2mm",
    accessRequestsStatusContainerInline: "_1e0c1o8l",
    accessRequestsStatusIndicatorOutline: "_2rko1qi0 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb19bv _4t3i19bv _kqswstnw _1pbykb7n",
    surfaceBackground: "_1ukrtuvp _ru4f1h6o _1ngpvuon _g87g116u _uohs13ro",
    overlayBackground: "_1ngp1bhr _g87g6o2t _uohsm8nx",
    accessRequestsStatusIndicator: "_2rko1qi0 _bfhkyhbg _1bsbi2wt _4t3ii2wt"
};
const $ad45489d485fda80$export$b86a366ed549a737 = ({ children: children, top: top, right: right, source: source, isInsideOverlay: isInsideOverlay = false, as: Container = 'div' })=>{
    const [showIndicator, setShowIndicator] = (0, $cozmU.useState)(false);
    const transform = `scale(${showIndicator ? 1 : 0})`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        return (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).subscribe(setShowIndicator);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: showIndicator ? 'shown' : 'hidden',
                actionSubject: 'pendingRequestIndicator',
                attributes: {
                    isInsideOverlay: isInsideOverlay
                },
                source: source
            }
        }).fire();
    }, [
        showIndicator,
        createAnalyticsEvent,
        isInsideOverlay,
        source
    ]);
    return /*#__PURE__*/ $cozmU.createElement(Container, {
        className: (0, $hekY6.default)([
            $ad45489d485fda80$var$styles.accessRequestsStatusContainer,
            Container === 'span' && $ad45489d485fda80$var$styles.accessRequestsStatusContainerInline,
            isInsideOverlay ? $ad45489d485fda80$var$styles.overlayBackground : $ad45489d485fda80$var$styles.surfaceBackground
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        id: "unseen-request-indicator",
        "data-testid": "unseen-request-indicator",
        style: {
            top: top,
            right: right,
            transform: transform
        },
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $ad45489d485fda80$var$styles.accessRequestsStatusIndicatorOutline,
            showIndicator && $ad45489d485fda80$var$styles.surfaceBackgroundVisible
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ad45489d485fda80$var$styles.accessRequestsStatusIndicator
        ])
    })), children);
};
const $ad45489d485fda80$export$91c5e709f5f88246 = (props)=>// eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_fe_realtime_access_requests', 'isEnabled', true) ? /*#__PURE__*/ $cozmU.createElement($ad45489d485fda80$export$b86a366ed549a737, props) : props.children;
module.exports["NewAccessRequestIndicator"] = $ad45489d485fda80$export$91c5e709f5f88246;

});

parcelRegister("eRpR8", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $2Oud5 = parcelRequire("2Oud5");

const $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED = (0, $1UApO.keys).LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED;
class $fcbf902ccbdfa629$export$78cb9c0f9b082b54 {
    _toggleIndicator(newState) {
        this._indicatorShown = newState;
        this._subscribers.forEach((sub)=>sub(newState));
    }
    _clearCache(contentId) {
        (0, $2Oud5.removeCachedTuple)(contentId, $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
    }
    subscribe(callback) {
        this._subscribers.add(callback);
        callback(this._indicatorShown);
        return ()=>{
            this._subscribers.delete(callback);
        };
    }
    updateIndicatorVisibility(contentId, mostRecentPendingRequestCreatedAt, lookback, remainingRequests) {
        if (lookback === 'full') {
            // No pending request remain whatsoever.
            // No need for 🔵. No need for cache.
            if (remainingRequests === 0) {
                this._clearCache(contentId);
                this._toggleIndicator(false);
                return;
            }
            // At least one pending request left
            // Check if it was created after last time Requests dialog was seen
            // If after -> show 🔵, If before -> hide 🔵
            const shouldShowIndicator = mostRecentPendingRequestCreatedAt > (0, $2Oud5.getCachedTimestamp)(contentId, $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
            this._toggleIndicator(shouldShowIndicator);
        } else {
            // At this point we know we're ONLY seeing requests X minutes back (likely 5)
            // I.e. "partial" lookback.
            const shouldShowIndicator = mostRecentPendingRequestCreatedAt > (0, $2Oud5.getCachedTimestamp)(contentId, $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
            // Since this is a partial lookback we can ONLY reliably show the 🔵
            // We cannot reliably hide the 🔵, because there might be older requests
            // that still happened AFTER last time Access Requests dialog was seen
            if (shouldShowIndicator) this._toggleIndicator(true);
        }
    }
    markAllRequestsAsSeen(contentId) {
        this._toggleIndicator(false);
        (0, $2Oud5.setCachedTuple)(contentId, Date.now(), $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
    }
    resetSubscribers() {
        this._indicatorShown = false;
        this._subscribers.clear();
    }
    constructor(){
        this._indicatorShown = false;
        this._subscribers = new Set();
    }
}
const $fcbf902ccbdfa629$export$8ccd90350e41eeed = new $fcbf902ccbdfa629$export$78cb9c0f9b082b54();
module.exports["NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE"] = $fcbf902ccbdfa629$export$8ccd90350e41eeed;

});

parcelRegister("9QsA9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $6mKj3 = parcelRequire("6mKj3");


var $a6t12 = parcelRequire("a6t12");

const $a3467ed07f2b3c98$var$styles = {
    triggerWrapper: "_1e0c1o8l _80omtlke"
};
const $a3467ed07f2b3c98$export$afe79a12afe4a7c = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { userId: userId, displayName: displayName, children: children, offset: offset } = t0;
    if (!userId || !(0, $6mKj3.expValEquals)("cc_fe_access_request_hover_card", "isEnabled", true)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== displayName || $[4] !== offset || $[5] !== userId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $a3467ed07f2b3c98$var$styles.triggerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            fullName: displayName,
            trigger: "hover",
            offset: offset
        }, children));
        $[2] = children;
        $[3] = displayName;
        $[4] = offset;
        $[5] = userId;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["AccessRequestProfileCardTrigger"] = $a3467ed07f2b3c98$export$afe79a12afe4a7c;

});

parcelRegister("lT8a1", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $6mKj3 = parcelRequire("6mKj3");


var $Qy97i = parcelRequire("Qy97i");

const $1b4f772a0e4dae00$var$iconSkeletonStyle = (0, $buxP3.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $1b4f772a0e4dae00$var$iconSkeletonWithMarginsStyle = (0, $buxP3.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    marginLeft: 'space.050',
    marginRight: 'space.025',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $1b4f772a0e4dae00$var$SkeletonGlyph = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: "icon-skeleton",
            xcss: (0, $6mKj3.expVal)("platform_editor_stabilise_ssr_vr_tests", "isEnabled", false) ? $1b4f772a0e4dae00$var$iconSkeletonStyle : $1b4f772a0e4dae00$var$iconSkeletonWithMarginsStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $1b4f772a0e4dae00$export$b125768944fa8b3 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            iconBefore: $1b4f772a0e4dae00$var$_temp,
            onClick: $1b4f772a0e4dae00$var$_temp2,
            isDisabled: true,
            testId: "share-and-restrict-button-placeholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $Qy97i.i18n).share));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $1b4f772a0e4dae00$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1b4f772a0e4dae00$var$SkeletonGlyph, null);
}
function $1b4f772a0e4dae00$var$_temp2() {}
module.exports["ShareAndRestrictButtonPlaceholder"] = $1b4f772a0e4dae00$export$b125768944fa8b3;

});

parcelRegister("jFm04", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

/**
 * @generated SignedSource<<dc48b8c9cf95f3382ce7b46c1b9d3e13>>
 * @relayHash d8d0a0c3773fb5614142ae8976c19503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2970b60e100eb92685e942d12759081a5851051628a93c78cf86833ab7f7f73
const $b42be9987d281f35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnershipDialogContentOwnerHistoryQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v8 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v8 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnershipDialogContentOwnerHistoryQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d8d0a0c3773fb5614142ae8976c19503",
            "id": "b2970b60e100eb92685e942d12759081a5851051628a93c78cf86833ab7f7f73",
            "metadata": {},
            "name": "ContentOwnershipDialogContentOwnerHistoryQuery",
            "operationKind": "query",
            "text": "query ContentOwnershipDialogContentOwnerHistoryQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdDate,createdBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}}"
        }
    };
}();
$b42be9987d281f35$var$node.hash = "e2c8f3dd7349e4f2eeb6723084505460";
var $b42be9987d281f35$export$2e2bcd8739ae039 = $b42be9987d281f35$var$node;


/**
 * @generated SignedSource<<4075f8ddd061d540c0ab54f9c65cfe82>>
 * @relayHash 15c4d5cd83724d2c377e03e67f0401a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04f1e2e12365470f1a82e7ad525acea578598fdcf526eb7c64d848b023824aba
const $79e030b4bb95f75a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isOwnerContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnershipDialogRefetchOnMutationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnershipDialogRefetchOnMutationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "15c4d5cd83724d2c377e03e67f0401a0",
            "id": "04f1e2e12365470f1a82e7ad525acea578598fdcf526eb7c64d848b023824aba",
            "metadata": {},
            "name": "ContentOwnershipDialogRefetchOnMutationQuery",
            "operationKind": "query",
            "text": "query ContentOwnershipDialogRefetchOnMutationQuery($contentId:ID!){contentContributors(id:$contentId){isOwnerContributor}}"
        }
    };
}();
$79e030b4bb95f75a$var$node.hash = "3c1d5e334c9e0f12e92785d43b19032c";
var $79e030b4bb95f75a$export$2e2bcd8739ae039 = $79e030b4bb95f75a$var$node;






var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $cDs9S = parcelRequire("cDs9S");


var $7ZB0A = parcelRequire("7ZB0A");


var $9DHhW = parcelRequire("9DHhW");


var $3jwuS = parcelRequire("3jwuS");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $ep3mz = parcelRequire("ep3mz");


var $7aRa9 = parcelRequire("7aRa9");


var $lsxnT = parcelRequire("lsxnT");


var $iquRY = parcelRequire("iquRY");


var $i28ZW = parcelRequire("i28ZW");


var $6mKj3 = parcelRequire("6mKj3");


var $kuujH = parcelRequire("kuujH");











var $hekY6 = parcelRequire("hekY6");

const $b6c0eda6d78c2bc7$export$824219d997137766 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11q71917 _2rkofajl _1yt4pxbi _1e0c1txw _19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q71917 _2rkofajl _1yt4pxbi _1e0c1txw _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$5f1af8db9871e1d6 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18s8vqg6",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8vqg6",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ecf8022a0b2d321f = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18u0pxbi _k48pwu06",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18u0pxbi _k48pwu06",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$b1a401d0eced3e7 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2lx21bp4 _11lvze3t _fl8bpxbi _1br9ze3t _pm7ize3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx21bp4 _11lvze3t _fl8bpxbi _1br9ze3t _pm7ize3t",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$e6dfd72ab29f8598 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8fhey _1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b6c0eda6d78c2bc7$export$7196851310a3d0bf = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "input" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19itglyw _4t3iidpf _1bsbidpf _nt751r31 _49pcglyw _1hvw1o36 _1ohhglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19itglyw _4t3iidpf _1bsbidpf _nt751r31 _49pcglyw _1hvw1o36 _1ohhglyw",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$124d4c7bf7db9715 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _oteh12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _oteh12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b6c0eda6d78c2bc7$export$d25f95f50a0dfdf9 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_80omtlke _1bsbf6fq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_80omtlke _1bsbf6fq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b6c0eda6d78c2bc7$export$69d5845bfe8a4fe9 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b6c0eda6d78c2bc7$export$3901cdc3044f6691 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2hwxv77o _15tynkob",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2hwxv77o _15tynkob",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$7b991bc77107aa2a = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4v47k _bfhkvuon _19pkv47k _1e0c1txw _4cvr1h6o _1bahitcz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4v47k _bfhkvuon _19pkv47k _1e0c1txw _4cvr1h6o _1bahitcz",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$b02238f37d00229c = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_16jlbs82 _1o9zkb7n _i0dlf1ug _1e0c1txw _p12f1jje _1bah1h6o _1wpz1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_16jlbs82 _1o9zkb7n _i0dlf1ug _1e0c1txw _p12f1jje _1bah1h6o _1wpz1y6m",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18u012x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$7fa76b0a88544135 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _syazazsu",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8fhey _k48p1wq8 _syazi7uo _p12f5rga",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _k48p1wq8 _syazi7uo _p12f5rga",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$cca08eed9de89ba9 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4pxbi _y3gnv2br _1bsb1gwv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4pxbi _y3gnv2br _1bsb1gwv",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$f006f5b646fd98c5 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4ze3t _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4ze3t _syazi7uo",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ad4d708bacf4d87d = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pk1ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$6a67697a421197fe = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41lhn _4t3i1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41lhn _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$6748052329e9b21a = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$8434332cb9a91069 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8fhey _kqswstnw _1pbyxnxo _1ltvmofv _154i1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _kqswstnw _1pbyxnxo _1ltvmofv _154i1ul9",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ba1d1c438cc57586 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_syaz15cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_syaz15cr",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$54e8379445658073 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3ildb6 _1e0c1txw _4cvr1h6o _1wpz1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3ildb6 _1e0c1txw _4cvr1h6o _1wpz1y6m",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$6316ca01164c199e = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _syazazsu _k48p1pd9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _syazazsu _k48p1pd9",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ac9f256b9beb0d3c = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "label" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _syazazsu _1e0c1ule _k48p1pd9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _syazazsu _1e0c1ule _k48p1pd9",
            __cmplp.className
        ])
    });
});



var $2E1L5 = parcelRequire("2E1L5");

/**
 * @generated SignedSource<<7c68f1d775a1b1d6ae9b79f09d90f1da>>
 * @relayHash cae771a5bdfb0acf2046a85914568a96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8a6a4cb4ee8fb082c4dabb9673b3f9b93f5c5c7d7b80b372753bc4806a167a9
const $119bf30f119f2d5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "ownerId",
                    "variableName": "ownerId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UpdateOwnerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateOwnerPayload",
                    "kind": "LinkedField",
                    "name": "updateOwner",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UpdateOwnerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateOwnerPayload",
                    "kind": "LinkedField",
                    "name": "updateOwner",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cae771a5bdfb0acf2046a85914568a96",
            "id": "d8a6a4cb4ee8fb082c4dabb9673b3f9b93f5c5c7d7b80b372753bc4806a167a9",
            "metadata": {},
            "name": "UpdateOwnerMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateOwnerMutation($contentId:ID!,$ownerId:String!){updateOwner(input:{contentId:$contentId,ownerId:$ownerId}){content{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}}}"
        }
    };
}();
$119bf30f119f2d5f$var$node.hash = "cdc1ca6586048959e4b974720b0962e3";
var $119bf30f119f2d5f$export$2e2bcd8739ae039 = $119bf30f119f2d5f$var$node;


const $93d3b821210dc608$export$86698751cb06e71c = (0, $119bf30f119f2d5f$export$2e2bcd8739ae039);



var $jFm04 = parcelRequire("jFm04");




















var $hpRYU = parcelRequire("hpRYU");


var $74Ff0 = parcelRequire("74Ff0");

const $8d0ff9fdc708c8d2$var$userPickerContainerStyles = (0, $buxP3.xcss)({
    marginTop: 'space.050',
    marginBottom: 'space.250'
});
/**
 * Required to generate the ref used to attach UserPicker's menu onto
 * Copied from next/packages/restrictions/src/RestrictionsDialog/RestrictionsDialogComponent.tsx
 */ const $8d0ff9fdc708c8d2$var$UserPickerRefContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [refSt, setRefSt] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (current)=>{
            ref.current = current;
            setRefSt(ref.current);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== refSt) {
        t2 = children(refSt);
        $[1] = children;
        $[2] = refSt;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: t1
        }, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children })=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [refSt, setRefSt] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: (current)=>{
            ref.current = current;
            setRefSt(ref.current);
        }
    }, children(refSt));
};
const $8d0ff9fdc708c8d2$export$c8d398915dca2120 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { selectedUser: selectedUser, onSelectUser: onSelectUser, onClearSelectedUser: onClearSelectedUser, spaceKey: spaceKey, contentId: contentId, currentOwner: currentOwner, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $[0] = contentId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const bootstrapOptions = (0, $74Ff0.useContentOwnershipContributors)(t1);
    let t2;
    if ($[3] !== currentOwner?.id) {
        t2 = (values)=>{
            const currentOwnerId = currentOwner?.id;
            return currentOwnerId ? values.filter((value)=>value.id !== currentOwnerId) : values;
        };
        $[3] = currentOwner?.id;
        $[4] = t2;
    } else t2 = $[4];
    const userResultsFilter = t2;
    let t3;
    if ($[5] !== ariaLabel || $[6] !== bootstrapOptions || $[7] !== onClearSelectedUser || $[8] !== onSelectUser || $[9] !== selectedUser || $[10] !== userResultsFilter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $8d0ff9fdc708c8d2$var$userPickerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d0ff9fdc708c8d2$var$UserPickerRefContainer, null, (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
                fieldId: "content.owner",
                ariaLabel: (0, $6mKj3.expValEquals)("a11y-fixes-week2-may-2026", "isEnabled", true) ? ariaLabel : undefined,
                value: selectedUser,
                onSelect: onSelectUser,
                onClear: onClearSelectedUser,
                width: "100%",
                isMulti: false,
                includeGroup: false,
                smart: true,
                isClearable: true,
                menuPortalTarget: ref || undefined,
                bootstrapOptions: bootstrapOptions,
                smartFilterOptions: userResultsFilter,
                styles: {
                    menuPortal: $8d0ff9fdc708c8d2$var$_temp
                },
                noOptionsMessage: null
            })));
        $[5] = ariaLabel;
        $[6] = bootstrapOptions;
        $[7] = onClearSelectedUser;
        $[8] = onSelectUser;
        $[9] = selectedUser;
        $[10] = userResultsFilter;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ selectedUser: selectedUser, onSelectUser: onSelectUser, onClearSelectedUser: onClearSelectedUser, spaceKey: spaceKey, contentId: contentId, currentOwner: currentOwner, ariaLabel: ariaLabel })=>{
    const bootstrapOptions = (0, $74Ff0.useContentOwnershipContributors)({
        contentId: contentId,
        spaceKey: spaceKey
    });
    // filter user dropdown results to exclude the current page owner
    const userResultsFilter = (values)=>{
        const currentOwnerId = currentOwner?.id;
        return currentOwnerId ? values.filter((value)=>value.id !== currentOwnerId) : values;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $8d0ff9fdc708c8d2$var$userPickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d0ff9fdc708c8d2$var$UserPickerRefContainer, null, (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
            fieldId: "content.owner",
            ariaLabel: (0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true) ? ariaLabel : undefined,
            value: selectedUser,
            onSelect: onSelectUser,
            onClear: onClearSelectedUser,
            width: "100%",
            isMulti: false,
            includeGroup: false,
            smart: true,
            isClearable: true,
            menuPortalTarget: ref || undefined,
            bootstrapOptions: bootstrapOptions,
            smartFilterOptions: userResultsFilter,
            styles: {
                menuPortal: (css)=>({
                        ...css,
                        position: 'absolute',
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        left: 'inherit',
                        // override positional attrs
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: 'inherit'
                    })
            },
            noOptionsMessage: null
        }))));
};
function $8d0ff9fdc708c8d2$var$_temp(css) {
    return {
        ...css,
        position: "absolute",
        left: "inherit",
        top: "inherit"
    };
}















var $kNIYN = parcelRequire("kNIYN");


var $lMGh1 = parcelRequire("lMGh1");





var $8aF6s = parcelRequire("8aF6s");


var $erzVD = parcelRequire("erzVD");


var $bVAxT = parcelRequire("bVAxT");


var $ePExc = parcelRequire("ePExc");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $3P1RK = parcelRequire("3P1RK");


















var $5k5SG = parcelRequire("5k5SG");


var $68BwE = parcelRequire("68BwE");







/**
 * @generated SignedSource<<aacb0fac5a7a9124f7b6d1b49eaa5272>>
 * @relayHash 462f52dcf04a704f3f189d003436f376
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce1b1ed0f6465ba08dafe0385b3804ddd4a83c3bcd0758bd9f55716b7e5f5b0
const $c2bfffab535ce88f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "accountType",
            "value": "ATLASSIAN"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "email"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "admins",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ],
                            "storageKey": "admins(accountType:\"ATLASSIAN\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "admins",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ],
                            "storageKey": "admins(accountType:\"ATLASSIAN\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "462f52dcf04a704f3f189d003436f376",
            "id": "7ce1b1ed0f6465ba08dafe0385b3804ddd4a83c3bcd0758bd9f55716b7e5f5b0",
            "metadata": {},
            "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipSpaceAdminsSpaceAdminsListQuery($spaceKey:String!){space(key:$spaceKey){id,admins(accountType:ATLASSIAN){__typename,type,...on KnownUser{email}}}}"
        }
    };
}();
$c2bfffab535ce88f$var$node.hash = "e7540581691bddbb5911e7d86948b5a5";
var $c2bfffab535ce88f$export$2e2bcd8739ae039 = $c2bfffab535ce88f$var$node;









var $jMyy4 = parcelRequire("jMyy4");

const $c83c690498928ef1$export$d51985cea2551a1b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [spaceAdminsList, setSpaceAdminsList] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !spaceKey;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $c2bfffab535ce88f$export$2e2bcd8739ae039), {
        ...t3,
        __callerPackage__: "content-ownership"
    });
    let t4;
    if ($[6] !== data?.space?.admins) {
        t4 = ()=>{
            const spaceAdmins = data?.space?.admins || [];
            setSpaceAdminsList([
                ...spaceAdmins
            ].filter($c83c690498928ef1$var$_temp));
        };
        $[6] = data?.space?.admins;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== data) {
        t5 = [
            data
        ];
        $[8] = data;
        $[9] = t5;
    } else t5 = $[9];
    (0, $cozmU.useEffect)(t4, t5);
    return spaceAdminsList;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [spaceAdminsList, setSpaceAdminsList] = (0, $cozmU.useState)([]);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $c2bfffab535ce88f$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey,
        __callerPackage__: "content-ownership"
    });
    (0, $cozmU.useEffect)(()=>{
        const spaceAdmins = data?.space?.admins || [];
        setSpaceAdminsList([
            ...spaceAdmins
        ].filter((admin)=>admin !== undefined));
    }, [
        data
    ]);
    return spaceAdminsList;
};
function $c83c690498928ef1$var$_temp(admin) {
    return admin !== undefined;
}








/**
 * @generated SignedSource<<98ad4f14dc6a4226dc641eafb39cc70e>>
 * @relayHash 02e5694eae05d544c06e2fa66565189c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14f9f5f6d6e0c64e5e92a784821105c630f04dd5684cd3348558eb13e8e4ebac
const $9d23db36bd693d24$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentInfoContentOwnershipContentInfoQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentInfoContentOwnershipContentInfoQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "02e5694eae05d544c06e2fa66565189c",
            "id": "14f9f5f6d6e0c64e5e92a784821105c630f04dd5684cd3348558eb13e8e4ebac",
            "metadata": {},
            "name": "useContentInfoContentOwnershipContentInfoQuery",
            "operationKind": "query",
            "text": "query useContentInfoContentOwnershipContentInfoQuery($contentId:ID!){singleContent(id:$contentId){id,title,status}}"
        }
    };
}();
$9d23db36bd693d24$var$node.hash = "bbc83213ee3157004ed18cf9c0a1713f";
var $9d23db36bd693d24$export$2e2bcd8739ae039 = $9d23db36bd693d24$var$node;








const $a79cf8ba6a83274a$export$5aaaa082bc10c9cc = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId } = t0;
    const [contentTitle, setContentTitle] = (0, $cozmU.useState)("");
    const [isArchived, setIsArchived] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $9d23db36bd693d24$export$2e2bcd8739ae039), {
        ...t1,
        __callerPackage__: "content-ownership"
    });
    let t2;
    if ($[2] !== data?.singleContent?.status || $[3] !== data?.singleContent?.title) {
        t2 = ()=>{
            const title = data?.singleContent?.title ?? "";
            const archived = data?.singleContent?.status === "archived";
            setContentTitle(title);
            setIsArchived(archived);
        };
        $[2] = data?.singleContent?.status;
        $[3] = data?.singleContent?.title;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== data) {
        t3 = [
            data
        ];
        $[5] = data;
        $[6] = t3;
    } else t3 = $[6];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== contentTitle || $[8] !== isArchived) {
        t4 = {
            contentTitle: contentTitle,
            isArchived: isArchived
        };
        $[7] = contentTitle;
        $[8] = isArchived;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ contentId: contentId })=>{
    const [contentTitle, setContentTitle] = (0, $cozmU.useState)('');
    const [isArchived, setIsArchived] = (0, $cozmU.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $9d23db36bd693d24$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "content-ownership"
    });
    (0, $cozmU.useEffect)(()=>{
        const title = data?.singleContent?.title ?? '';
        const archived = data?.singleContent?.status === 'archived';
        setContentTitle(title);
        setIsArchived(archived);
    }, [
        data
    ]);
    return {
        contentTitle: contentTitle,
        isArchived: isArchived
    };
};


const $eed1915733801f58$var$SpaceRestrictionButton = ({ intl: intl, displayName: displayName, contentId: contentId, selectedUser: selectedUser })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const { canManageUsers: canManageUsers } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    });
    const canManageSpacePermissions = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageUsers || isSiteAdmin : isSpaceOrSiteAdmin;
    const spacePermissionsUrl = `${(0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
        spaceKey: spaceKey,
        tab: (0, $3P1RK.SpacePermissionsTabKey).Users
    })}`;
    const SpaceAdminRestrictionButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "link",
            href: spacePermissionsUrl,
            target: "_blank"
        }, intl.formatMessage((0, $kuujH.i18n).manageSpaceRestrictionButtonAdmin));
    };
    const SpaceUserRestrictionButton = ()=>{
        const spaceAdmins = (0, $c83c690498928ef1$export$d51985cea2551a1b)();
        const { contentTitle: contentTitle } = (0, $a79cf8ba6a83274a$export$5aaaa082bc10c9cc)({
            contentId: contentId
        });
        const mailtoLink = (0, $68BwE.generateMailtoLink)({
            intl: intl,
            spaceAdmins: spaceAdmins,
            spacePermissionsUrl: spacePermissionsUrl,
            spaceKey: spaceKey,
            contentId: contentId,
            requestedUser: selectedUser?.name,
            currentUser: displayName,
            pageTitle: contentTitle
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "link",
            href: mailtoLink
        }, intl.formatMessage((0, $kuujH.i18n).manageSpaceRestrictionButton));
    };
    return canManageSpacePermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpaceAdminRestrictionButton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpaceUserRestrictionButton, null);
};
const $eed1915733801f58$var$ParentPageRestrictionButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { intl: intl, contentId: contentId, isPremium: isPremium } = t0;
    const [showInspectPermissions, setShowInspectPermissions] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== intl || $[1] !== isPremium) {
        t1 = isPremium ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "link",
            onClick: ()=>setShowInspectPermissions(true)
        }, intl.formatMessage((0, $kuujH.i18n).managePremiumRestrictionButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "link",
            target: "_blank",
            href: (0, $2E1L5.PARENT_PAGE_LEARN_MORE_URL)
        }, intl.formatMessage((0, $kuujH.i18n).manageParentPageRestrictionButton));
        $[0] = intl;
        $[1] = isPremium;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== contentId || $[4] !== showInspectPermissions) {
        t2 = showInspectPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $erzVD.InspectPermissionsDialog), {
            contentId: contentId,
            onClose: ()=>setShowInspectPermissions(false)
        });
        $[3] = contentId;
        $[4] = showInspectPermissions;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ intl: intl, contentId: contentId, isPremium: isPremium })=>{
    const [showInspectPermissions, setShowInspectPermissions] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isPremium ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: ()=>setShowInspectPermissions(true)
    }, intl.formatMessage((0, $kuujH.i18n).managePremiumRestrictionButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        target: "_blank",
        href: (0, $2E1L5.PARENT_PAGE_LEARN_MORE_URL)
    }, intl.formatMessage((0, $kuujH.i18n).manageParentPageRestrictionButton)), showInspectPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $erzVD.InspectPermissionsDialog), {
        contentId: contentId,
        onClose: ()=>setShowInspectPermissions(false)
    }));
};
const $eed1915733801f58$var$ManageAccessButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { intl: intl, resetRestrictions: resetRestrictions, recheckAccess: recheckAccess, contentId: contentId, contentType: contentType, spaceKey: spaceKey } = t0;
    const dialogs = (0, $8aF6s.useDialogs)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== contentType || $[3] !== dialogs || $[4] !== intl || $[5] !== recheckAccess || $[6] !== resetRestrictions || $[7] !== spaceKey) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t1
        }, (dialogState)=>{
            const handleManageAccessClick = ()=>{
                if ((0, $6mKj3.expVal)("confluence_frontend_deprecate_restrictions_dialog", "isEnabled", false)) {
                    const recheckOnClose = recheckAccess ?? resetRestrictions;
                    dialogs.showModal((0, $ePExc.ShareAndRestrictDialogController), {
                        contentId: contentId,
                        contentType: contentType,
                        allowRestrictions: true,
                        pageMode: "view",
                        onCloseComplete: recheckOnClose,
                        hasInheritedRestrictions: false,
                        isUnpublishedDraft: false,
                        spaceKey: spaceKey,
                        openFrom: "content-ownership"
                    });
                } else {
                    dialogState.setIsOpen(true);
                    resetRestrictions();
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "link",
                onClick: handleManageAccessClick
            }, intl.formatMessage((0, $kuujH.i18n).manageRestrictionButton));
        });
        $[1] = contentId;
        $[2] = contentType;
        $[3] = dialogs;
        $[4] = intl;
        $[5] = recheckAccess;
        $[6] = resetRestrictions;
        $[7] = spaceKey;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ intl: intl, resetRestrictions: resetRestrictions, recheckAccess: recheckAccess, contentId: contentId, contentType: contentType, spaceKey: spaceKey })=>{
    const dialogs = (0, $8aF6s.useDialogs)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogState)=>{
        const handleManageAccessClick = ()=>{
            if ((0, $6mKj3.expVal)('confluence_frontend_deprecate_restrictions_dialog', 'isEnabled', false)) {
                const recheckOnClose = recheckAccess ?? resetRestrictions;
                dialogs.showModal((0, $ePExc.ShareAndRestrictDialogController), {
                    contentId: contentId,
                    contentType: contentType,
                    allowRestrictions: true,
                    pageMode: 'view',
                    onCloseComplete: recheckOnClose,
                    hasInheritedRestrictions: false,
                    isUnpublishedDraft: false,
                    spaceKey: spaceKey,
                    openFrom: 'content-ownership'
                });
            } else {
                dialogState.setIsOpen(true);
                resetRestrictions();
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "link",
            onClick: handleManageAccessClick
        }, intl.formatMessage((0, $kuujH.i18n).manageRestrictionButton));
    });
};
const $eed1915733801f58$export$ea9ef81cc32c3347 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { isParentPageRestriction: t1, isSpaceRestricted: t2, isEditPageRestricted: t3, contentId: t4, contentType: contentType, spaceKey: spaceKey, selectedUser: selectedUser, resetRestrictions: resetRestrictions, recheckAccess: recheckAccess } = t0;
    const isParentPageRestriction = t1 === undefined ? false : t1;
    const isSpaceRestricted = t2 === undefined ? false : t2;
    const isEditPageRestricted = t3 === undefined ? false : t3;
    const contentId = t4 === undefined ? "" : t4;
    const intl = (0, $kSwu1.useIntl)();
    const { edition: edition, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let restrictionTitle;
    let restrictionMessage;
    if (isSpaceRestricted) {
        restrictionTitle = (0, $kuujH.i18n).ownerSpaceRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerSpaceRestrictionMessage;
    } else if (isPremium && isParentPageRestriction) {
        restrictionTitle = (0, $kuujH.i18n).ownerPremiumRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerPremiumRestrictionMessage;
    } else {
        if (isParentPageRestriction) {
            restrictionTitle = (0, $kuujH.i18n).ownerParentPageRestrictionTitle;
            restrictionMessage = (0, $kuujH.i18n).ownerParentPageRestrictionMessage;
        } else if (isEditPageRestricted) {
            restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
            restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
        } else {
            restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
            restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
        }
    }
    let restrictionButton;
    if (isSpaceRestricted) {
        let t5;
        if ($[0] !== contentId || $[1] !== displayName || $[2] !== intl || $[3] !== selectedUser) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eed1915733801f58$var$SpaceRestrictionButton, {
                intl: intl,
                displayName: displayName,
                selectedUser: selectedUser,
                contentId: contentId
            });
            $[0] = contentId;
            $[1] = displayName;
            $[2] = intl;
            $[3] = selectedUser;
            $[4] = t5;
        } else t5 = $[4];
        restrictionButton = t5;
    } else if (isParentPageRestriction) {
        let t5;
        if ($[5] !== contentId || $[6] !== intl || $[7] !== isPremium) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eed1915733801f58$var$ParentPageRestrictionButton, {
                intl: intl,
                contentId: contentId,
                isPremium: isPremium
            });
            $[5] = contentId;
            $[6] = intl;
            $[7] = isPremium;
            $[8] = t5;
        } else t5 = $[8];
        restrictionButton = t5;
    } else {
        let t5;
        if ($[9] !== contentId || $[10] !== contentType || $[11] !== intl || $[12] !== recheckAccess || $[13] !== resetRestrictions || $[14] !== spaceKey) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eed1915733801f58$var$ManageAccessButton, {
                intl: intl,
                resetRestrictions: resetRestrictions,
                recheckAccess: recheckAccess,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey
            });
            $[9] = contentId;
            $[10] = contentType;
            $[11] = intl;
            $[12] = recheckAccess;
            $[13] = resetRestrictions;
            $[14] = spaceKey;
            $[15] = t5;
        } else t5 = $[15];
        restrictionButton = t5;
    }
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-text-warning, #9E4C00)"
        });
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== intl || $[18] !== restrictionTitle) {
        t6 = intl.formatMessage(restrictionTitle);
        $[17] = intl;
        $[18] = restrictionTitle;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$ecf8022a0b2d321f), null, t6);
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== intl || $[23] !== restrictionMessage) {
        t8 = intl.formatMessage(restrictionMessage);
        $[22] = intl;
        $[23] = restrictionMessage;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$5f1af8db9871e1d6), null, t8);
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== restrictionButton || $[28] !== t7 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$824219d997137766), {
            "data-testid": "content-ownership-permissions-warning-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$e6dfd72ab29f8598), null, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$b1a401d0eced3e7), null, t7, t9, restrictionButton)));
        $[27] = restrictionButton;
        $[28] = t7;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ({ isParentPageRestriction: isParentPageRestriction = false, isSpaceRestricted: isSpaceRestricted = false, isEditPageRestricted: isEditPageRestricted = false, contentId: contentId = '', contentType: contentType, spaceKey: spaceKey, selectedUser: selectedUser, resetRestrictions: resetRestrictions, recheckAccess: recheckAccess })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { edition: edition, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    // Set i18n title and message based on restrictionType
    let restrictionTitle = {};
    let restrictionMessage = {};
    if (isSpaceRestricted) {
        restrictionTitle = (0, $kuujH.i18n).ownerSpaceRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerSpaceRestrictionMessage;
    } else if (isPremium && isParentPageRestriction) {
        restrictionTitle = (0, $kuujH.i18n).ownerPremiumRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerPremiumRestrictionMessage;
    } else if (isParentPageRestriction) {
        restrictionTitle = (0, $kuujH.i18n).ownerParentPageRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerParentPageRestrictionMessage;
    } else if (isEditPageRestricted) {
        restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
    } else {
        restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
    }
    let restrictionButton = null;
    if (isSpaceRestricted) restrictionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eed1915733801f58$var$SpaceRestrictionButton, {
        intl: intl,
        displayName: displayName,
        selectedUser: selectedUser,
        contentId: contentId
    });
    else if (isParentPageRestriction) // Premium link renders inspect permissions dialog
    restrictionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eed1915733801f58$var$ParentPageRestrictionButton, {
        intl: intl,
        contentId: contentId,
        isPremium: isPremium
    });
    else // Default opens permissions dialog
    restrictionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eed1915733801f58$var$ManageAccessButton, {
        intl: intl,
        resetRestrictions: resetRestrictions,
        recheckAccess: recheckAccess,
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$824219d997137766), {
        "data-testid": "content-ownership-permissions-warning-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$e6dfd72ab29f8598), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text-warning, #9E4C00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$b1a401d0eced3e7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$ecf8022a0b2d321f), null, intl.formatMessage(restrictionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$5f1af8db9871e1d6), null, intl.formatMessage(restrictionMessage)), restrictionButton)));
};


















var $4aRua = parcelRequire("4aRua");

















var $aRvnq = parcelRequire("aRvnq");














const $16a863bb4ebc026d$export$e07e2fe8dd18723a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(50);
    const { onCancel: onCancel, onConfirm: onConfirm, currentOwner: currentOwner, newOwner: newOwner } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $kuujH.i18n).confirmModalTitle);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, t1));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage((0, $kuujH.i18n).confirmModalBody, {
            button: $16a863bb4ebc026d$var$_temp
        });
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "p"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = currentOwner?.avatarUrl;
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            size: "medium",
            src: t5
        });
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$7fa76b0a88544135), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $kuujH.i18n).confirmModalCurrentOwner));
        $[10] = t7;
    } else t7 = $[10];
    const t8 = currentOwner?.fullName;
    let t9;
    if ($[11] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2), null, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77), null, t8));
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== t6 || $[14] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$b02238f37d00229c), {
            "data-testid": "content-owner-confirm-modal-current-user"
        }, t6, t9);
        $[13] = t6;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$54e8379445658073), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$6a67697a421197fe), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Ownership Transfer"
        })));
        $[16] = t11;
    } else t11 = $[16];
    const t12 = newOwner?.avatarUrl;
    let t13;
    if ($[17] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            size: "medium",
            src: t12
        });
        $[17] = t12;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$7fa76b0a88544135), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $kuujH.i18n).confirmModalNewOwner));
        $[19] = t14;
    } else t14 = $[19];
    const t15 = newOwner?.fullName;
    let t16;
    if ($[20] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2), null, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77), null, t15));
        $[20] = t15;
        $[21] = t16;
    } else t16 = $[21];
    let t17;
    if ($[22] !== t13 || $[23] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$b02238f37d00229c), {
            "data-testid": "content-owner-confirm-modal-new-user"
        }, t13, t16);
        $[22] = t13;
        $[23] = t16;
        $[24] = t17;
    } else t17 = $[24];
    let t18;
    if ($[25] !== t10 || $[26] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$7b991bc77107aa2a), null, t10, t11, t17);
        $[25] = t10;
        $[26] = t17;
        $[27] = t18;
    } else t18 = $[27];
    let t19;
    if ($[28] !== t18 || $[29] !== t4) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, t4, t18);
        $[28] = t18;
        $[29] = t4;
        $[30] = t19;
    } else t19 = $[30];
    let t20;
    if ($[31] !== intl) {
        t20 = intl.formatMessage((0, $kuujH.i18n).confirmModalCancel);
        $[31] = intl;
        $[32] = t20;
    } else t20 = $[32];
    let t21;
    if ($[33] !== onCancel || $[34] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "content-owner-modal-cancel-update-owner-button",
            appearance: "subtle",
            onClick: onCancel
        }, t20);
        $[33] = onCancel;
        $[34] = t20;
        $[35] = t21;
    } else t21 = $[35];
    let t22;
    if ($[36] !== intl) {
        t22 = intl.formatMessage((0, $kuujH.i18n).confirmModalConfirmChangeOwner);
        $[36] = intl;
        $[37] = t22;
    } else t22 = $[37];
    let t23;
    if ($[38] !== onConfirm || $[39] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "content-owner-modal-confirm-update-owner-button",
            appearance: "warning",
            onClick: onConfirm
        }, t22);
        $[38] = onConfirm;
        $[39] = t22;
        $[40] = t23;
    } else t23 = $[40];
    let t24;
    if ($[41] !== t21 || $[42] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$124d4c7bf7db9715), null, t21, t23));
        $[41] = t21;
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== Modal || $[45] !== onCancel || $[46] !== t19 || $[47] !== t2 || $[48] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            testId: "content-owner-confirm-modal",
            onClose: onCancel,
            width: "small",
            messageType: "transactional",
            messageId: "content-ownership-confirm-modal"
        }, t2, t19, t24);
        $[44] = Modal;
        $[45] = onCancel;
        $[46] = t19;
        $[47] = t2;
        $[48] = t24;
        $[49] = t25;
    } else t25 = $[49];
    return t25;
} : ({ onCancel: onCancel, onConfirm: onConfirm, currentOwner: currentOwner, newOwner: newOwner })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        testId: "content-owner-confirm-modal",
        onClose: onCancel,
        width: "small",
        messageType: "transactional",
        messageId: "content-ownership-confirm-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        as: "p"
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalBody, {
        button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "link",
                spacing: "none",
                target: "_blank",
                href: (0, $2E1L5.CONFIRM_MODAL_LEARN_MORE_LINK)
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$7b991bc77107aa2a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$b02238f37d00229c), {
        "data-testid": "content-owner-confirm-modal-current-user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        size: "medium",
        src: currentOwner?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$7fa76b0a88544135), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $kuujH.i18n).confirmModalCurrentOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77), null, currentOwner?.fullName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$54e8379445658073), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$6a67697a421197fe), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "Ownership Transfer"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$b02238f37d00229c), {
        "data-testid": "content-owner-confirm-modal-new-user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        size: "medium",
        src: newOwner?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$7fa76b0a88544135), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $kuujH.i18n).confirmModalNewOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77), null, newOwner?.fullName))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$124d4c7bf7db9715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "content-owner-modal-cancel-update-owner-button",
        appearance: "subtle",
        onClick: onCancel
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "content-owner-modal-confirm-update-owner-button",
        appearance: "warning",
        onClick: onConfirm
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalConfirmChangeOwner)))));
};
function $16a863bb4ebc026d$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        spacing: "none",
        target: "_blank",
        href: (0, $2E1L5.CONFIRM_MODAL_LEARN_MORE_LINK)
    }, chunks);
}









var $6s78L = parcelRequire("6s78L");

const $d47aff8da3f39616$var$ContentOwnershipDialogRefetchOnMutationQuery = (0, $79e030b4bb95f75a$export$2e2bcd8739ae039);
const $d47aff8da3f39616$var$ContentOwnershipDialogContentOwnerHistoryQuery = (0, $b42be9987d281f35$export$2e2bcd8739ae039);
const $d47aff8da3f39616$var$currentOwnerContainer = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $d47aff8da3f39616$var$photoAndNameContainer = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 'space.200'
});
const $d47aff8da3f39616$var$nameContainer = (0, $buxP3.xcss)({
    marginLeft: 'space.075'
});
const $d47aff8da3f39616$var$ContentOwnershipDialogComponent = ({ flags: flags, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [selectedUser, setSelectedUser] = (0, $cozmU.useState)(undefined);
    const [currentOwner, setCurrentOwner] = (0, $cozmU.useState)(undefined);
    const [isRequestInFlight, setIsRequestInFlight] = (0, $cozmU.useState)(false);
    const [showConfirmModal, setShowConfirmModal] = (0, $cozmU.useState)(false);
    const [restrictions, setRestrictions] = (0, $cozmU.useState)({
        isUserRestricted: false,
        isSpaceRestricted: false,
        isParentPageRestricted: false,
        isEditPageRestricted: false
    });
    const { closeModal: closeModal, onOwnerChange: onOwnerChange } = (0, $jFm04.useContentOwnershipContext)();
    const isAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const { canManageContent: canManageContent, loading: isLoadingSpaceManagementOperations } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey
    });
    const canBypassConfirmModal = isRbacEnabled ? canManageContent : isAdmin;
    const { data: data } = (0, $jMyy4.useQueryInterop)($d47aff8da3f39616$var$ContentOwnershipDialogContentOwnerHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        __callerPackage__: "content-ownership"
    });
    (0, $cozmU.useEffect)(()=>{
        if (!data) return;
        let ownerId;
        const ownerData = data?.singleContent?.history?.ownedBy;
        if (ownerData && 'accountId' in ownerData) ownerId = ownerData.accountId ?? undefined;
        const owner = {
            fullName: ownerData?.displayName ?? undefined,
            avatarUrl: ownerData?.profilePicture?.path ?? undefined,
            id: ownerId
        };
        setCurrentOwner(owner);
    }, [
        data
    ]);
    (0, $cozmU.useEffect)(()=>{
        const { isUserRestricted: isUserRestricted, isSpaceRestricted: isSpaceRestricted, isParentPageRestricted: isParentPageRestricted } = restrictions;
        if (isUserRestricted || isSpaceRestricted || isParentPageRestricted) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'changeErrorPermissionWarning',
                actionSubject: 'content.owner',
                source: 'changeOwnerModal',
                attributes: {
                    ...restrictions,
                    contentId: contentId,
                    isAdmin: isAdmin,
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        restrictions,
        createAnalyticsEvent,
        contentId,
        isAdmin,
        contentType
    ]);
    const resetRestrictions = ()=>{
        setRestrictions({
            isUserRestricted: false,
            isSpaceRestricted: false,
            isParentPageRestricted: false,
            isEditPageRestricted: false
        });
    };
    const recheckSelectedUserAccess = (0, $cozmU.useCallback)(async ()=>{
        if (!selectedUser?.id) {
            setRestrictions({
                isUserRestricted: false,
                isSpaceRestricted: false,
                isParentPageRestricted: false,
                isEditPageRestricted: false
            });
            return;
        }
        const newRestrictions = await (0, $68BwE.checkIsUserRestricted)(contentId, selectedUser.id, 'network-only').catch((error)=>{
            // We intentionally log only the error class name and a network-error flag
            // instead of error.message. The backend resolver for userWithContentRestrictions
            // interpolates the user's accountId (AAID) into NotFoundException messages
            // (e.g. "User not found: 557058:..."). Whether AGG strips these before they
            // reach the client is unverified, so we treat error.message as potentially
            // containing PII. Logging raw error messages in analytics is an auto-SEV2
            // risk per Atlassian policy — we classify the error type instead.
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'recheckUserAccess',
                    source: 'changeOwnerModal',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        errorName: error instanceof Error ? error.name : 'UnknownError',
                        isNetworkError: error instanceof Error && 'networkError' in error
                    }
                }
            }).fire();
            flags.showErrorFlag({
                id: 'content-ownership-recheck-access-failed',
                title: intl.formatMessage((0, $kuujH.i18n).recheckAccessFailedFlagMessage),
                isAutoDismiss: true
            });
            return undefined;
        });
        if (newRestrictions) setRestrictions(newRestrictions);
    }, [
        contentId,
        selectedUser,
        contentType,
        createAnalyticsEvent,
        flags,
        intl
    ]);
    const handleShowConfirmModal = (0, $cozmU.useCallback)(()=>{
        setShowConfirmModal(true);
    }, []);
    const handleHideConfirmModal = (0, $cozmU.useCallback)(()=>{
        setShowConfirmModal(false);
    }, []);
    // TODO: The user picker itself doesn't seem to get cleared
    const handleClearSelectedUser = (0, $cozmU.useCallback)(()=>{
        setSelectedUser(undefined);
        resetRestrictions();
    }, []);
    const handleSelectUser = (0, $cozmU.useCallback)(async (user)=>{
        setIsRequestInFlight(true);
        setSelectedUser(user);
        const newRestrictions_0 = await (0, $68BwE.checkIsUserRestricted)(contentId, user.id);
        if (newRestrictions_0) setRestrictions(newRestrictions_0);
        else resetRestrictions();
        setIsRequestInFlight(false);
        if ((0, $6mKj3.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) // Restore focus to the combobox input after the user selection closes the dropdown
        // This prevents focus from incorrectly moving to the modal Close button (WCAG 3.2.2)
        setTimeout(()=>{
            if (typeof document !== 'undefined') {
                const input = document.getElementById('react-select-content.owner-input');
                input?.focus();
            }
        }, 0);
    }, [
        contentId
    ]);
    const tryUpdateOwner = (0, $cozmU.useCallback)(async ()=>{
        try {
            experienceTracker.start({
                name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE)
            });
            setIsRequestInFlight(true);
            const newOwnerId = selectedUser.id;
            try {
                const mutationResult = await (0, $6s78L.mutateInterop)({
                    mutation: (0, $93d3b821210dc608$export$86698751cb06e71c),
                    variables: {
                        contentId: contentId,
                        ownerId: newOwnerId
                    },
                    refetchQueries: [
                        {
                            query: $d47aff8da3f39616$var$ContentOwnershipDialogRefetchOnMutationQuery,
                            variables: {
                                contentId: contentId
                            }
                        },
                        {
                            query: $d47aff8da3f39616$var$ContentOwnershipDialogContentOwnerHistoryQuery,
                            variables: {
                                contentId: contentId
                            }
                        }
                    ],
                    __callerPackage__: "content-ownership"
                });
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'changeSuccess',
                        actionSubject: 'content.owner',
                        source: 'changeOwnerModal',
                        attributes: {
                            contentId: contentId,
                            isAdmin: isAdmin,
                            isLivePage: isLivePage,
                            contentType: contentType
                        }
                    }
                }).fire();
                experienceTracker.succeed({
                    name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE)
                });
                onOwnerChange?.(currentOwner?.id ?? '', newOwnerId);
                closeModal();
                flags.showSuccessFlag({
                    id: 'content-ownership-dialog-update-owner-success',
                    title: intl.formatMessage((0, $kuujH.i18n).successFlagMessage, {
                        user: mutationResult?.data?.updateOwner?.content?.history?.ownedBy?.displayName
                    }),
                    isAutoDismiss: true
                });
            } catch (error) {
                // if the attempt to update owner fails due to
                // new owner lacking page view / edit permissions
                if (error.message.includes((0, $2E1L5.EXPECTED_ERROR_MESSAGES).USER_MISSING_PAGE_PERMISSION)) {
                    experienceTracker.abort({
                        name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE),
                        reason: 'New owner does not have view/edit permission on the page'
                    });
                    setRestrictions({
                        ...restrictions,
                        isUserRestricted: true
                    });
                } else experienceTracker.fail({
                    name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE),
                    error: error
                });
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'changeError',
                        actionSubject: 'content.owner',
                        source: 'changeOwnerModal',
                        attributes: {
                            ...error,
                            contentId: contentId,
                            isAdmin: isAdmin,
                            isLivePage: isLivePage,
                            contentType: contentType
                        }
                    }
                }).fire();
                flags.showErrorFlag({
                    id: 'content-ownership-dialog-update-owner-failed',
                    title: intl.formatMessage((0, $kuujH.i18n).errorFlagMessage),
                    isAutoDismiss: true
                });
            }
        } finally{
            setIsRequestInFlight(false);
        }
    }, [
        selectedUser,
        contentId,
        closeModal,
        restrictions,
        createAnalyticsEvent,
        isAdmin,
        experienceTracker,
        isLivePage,
        flags,
        intl,
        contentType,
        onOwnerChange,
        currentOwner?.id
    ]);
    const handleConfirmChange = (0, $cozmU.useCallback)(async ()=>{
        setShowConfirmModal(false);
        await tryUpdateOwner();
    }, [
        tryUpdateOwner
    ]);
    const onChangeButtonHandler = (0, $cozmU.useMemo)(()=>{
        return canBypassConfirmModal ? tryUpdateOwner : handleShowConfirmModal;
    }, [
        canBypassConfirmModal,
        tryUpdateOwner,
        handleShowConfirmModal
    ]);
    if (!spaceKey || !contentId) return null;
    if (!currentOwner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        testId: "content-owner-modal",
        onClose: closeModal,
        messageType: "transactional",
        messageId: "content-ownership-modal",
        shouldReturnFocus: shouldReturnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, intl.formatMessage((0, $kuujH.i18n).modalTitleEnabledForAllContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: closeModal,
        label: intl.formatMessage((0, $kuujH.i18n).closeModal)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $d47aff8da3f39616$var$currentOwnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$6316ca01164c199e), null, intl.formatMessage((0, $kuujH.i18n).modalCurrentOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $d47aff8da3f39616$var$photoAndNameContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: currentOwner?.avatarUrl,
        name: (0, $6mKj3.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? undefined : currentOwner?.fullName,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $d47aff8da3f39616$var$nameContainer,
        as: "span"
    }, currentOwner?.fullName))), (0, $6mKj3.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$ac9f256b9beb0d3c), {
        htmlFor: "react-select-content.owner-input",
        "data-testid": "content-owner-modal--new-owner-label"
    }, intl.formatMessage((0, $kuujH.i18n).modalBodyEnabledForAllContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$6316ca01164c199e), {
        "data-testid": "content-owner-modal--new-owner-label"
    }, intl.formatMessage((0, $kuujH.i18n).modalBodyEnabledForAllContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8d0ff9fdc708c8d2$export$c8d398915dca2120), {
        selectedUser: selectedUser,
        onSelectUser: handleSelectUser,
        onClearSelectedUser: handleClearSelectedUser,
        spaceKey: spaceKey,
        contentId: contentId,
        currentOwner: currentOwner,
        ariaLabel: intl.formatMessage((0, $kuujH.i18n).modalBodyEnabledForAllContent)
    }), restrictions.isUserRestricted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eed1915733801f58$export$ea9ef81cc32c3347), {
        isParentPageRestriction: restrictions.isParentPageRestricted,
        isEditPageRestricted: restrictions.isEditPageRestricted,
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        isSpaceRestricted: restrictions.isSpaceRestricted,
        selectedUser: selectedUser,
        resetRestrictions: resetRestrictions,
        recheckAccess: recheckSelectedUserAccess
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6c0eda6d78c2bc7$export$124d4c7bf7db9715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: closeModal
    }, intl.formatMessage((0, $kuujH.i18n).modalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "content-owner-modal-update-owner-button",
        appearance: "primary",
        onClick: onChangeButtonHandler,
        isDisabled: !selectedUser || restrictions.isUserRestricted || isRequestInFlight || isLoadingSpaceRoleMode || isLoadingSpaceManagementOperations
    }, intl.formatMessage((0, $kuujH.i18n).modalChangeOwner))))), showConfirmModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16a863bb4ebc026d$export$e07e2fe8dd18723a), {
        onCancel: handleHideConfirmModal,
        onConfirm: handleConfirmChange,
        currentOwner: currentOwner,
        newOwner: {
            fullName: selectedUser.name,
            avatarUrl: selectedUser.avatarUrl,
            id: selectedUser.id
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType,
            isLivePage: isLivePage
        }
    }));
};
const $d47aff8da3f39616$export$c4b58737fceb9315 = (0, $7aRa9.withFlags)(({ flags: flags, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const { isModalOpen: isModalOpen } = (0, $jFm04.useContentOwnershipContext)();
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d47aff8da3f39616$var$ContentOwnershipDialogComponent, {
        flags: flags,
        shouldReturnFocusRef: shouldReturnFocusRef
    });
});


const $30c826ecad02059a$var$ContentOwnershipContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isModalOpen: false,
    openModal: ()=>{
    /* no-op */ },
    closeModal: ()=>{
    /* no-op */ }
});
const $30c826ecad02059a$export$22f379f031a59eaa = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, onOwnerChange: onOwnerChange } = t0;
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [returnFocusRef, setReturnFocusRef] = (0, $cozmU.useState)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (args)=>{
            setIsModalOpen(true);
            if (args?.returnFocusRef) setReturnFocusRef(args.returnFocusRef);
        };
        $[0] = t1;
    } else t1 = $[0];
    const openModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsModalOpen(false);
        $[1] = t2;
    } else t2 = $[1];
    const closeModal = t2;
    let t3;
    if ($[2] !== isModalOpen || $[3] !== onOwnerChange) {
        t3 = {
            isModalOpen: isModalOpen,
            openModal: openModal,
            closeModal: closeModal,
            onOwnerChange: onOwnerChange
        };
        $[2] = isModalOpen;
        $[3] = onOwnerChange;
        $[4] = t3;
    } else t3 = $[4];
    const contentOwnershipContextValue = t3;
    let t4;
    if ($[5] !== returnFocusRef) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d47aff8da3f39616$export$c4b58737fceb9315), {
            shouldReturnFocusRef: returnFocusRef
        });
        $[5] = returnFocusRef;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== children || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children, t4);
        $[7] = children;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== contentOwnershipContextValue || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30c826ecad02059a$var$ContentOwnershipContext.Provider, {
            value: contentOwnershipContextValue
        }, t5);
        $[10] = contentOwnershipContextValue;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ children: children, onOwnerChange: onOwnerChange })=>{
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [returnFocusRef, setReturnFocusRef] = (0, $cozmU.useState)();
    const openModal = (0, $cozmU.useCallback)((args)=>{
        setIsModalOpen(true);
        if (args?.returnFocusRef) setReturnFocusRef(args.returnFocusRef);
    }, []);
    const closeModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(false), []);
    const contentOwnershipContextValue = (0, $cozmU.useMemo)(()=>({
            isModalOpen: isModalOpen,
            openModal: openModal,
            closeModal: closeModal,
            onOwnerChange: onOwnerChange
        }), [
        isModalOpen,
        openModal,
        closeModal,
        onOwnerChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30c826ecad02059a$var$ContentOwnershipContext.Provider, {
        value: contentOwnershipContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d47aff8da3f39616$export$c4b58737fceb9315), {
        shouldReturnFocusRef: returnFocusRef
    })));
};
const $30c826ecad02059a$export$e047c3e72baa9533 = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30c826ecad02059a$export$22f379f031a59eaa, {
            onOwnerChange: props.onOwnerChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
const $30c826ecad02059a$export$1e71db018b220386 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($30c826ecad02059a$var$ContentOwnershipContext);
} : ()=>{
    return (0, $cozmU.useContext)($30c826ecad02059a$var$ContentOwnershipContext);
};
const $30c826ecad02059a$export$d8bfa07cf352465c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const context = $30c826ecad02059a$export$1e71db018b220386();
    let t1;
    if ($[0] !== children || $[1] !== context) {
        t1 = children(context);
        $[0] = children;
        $[1] = context;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const context = $30c826ecad02059a$export$1e71db018b220386();
    return children(context);
};
module.exports["ContentOwnershipContextProvider"] = $30c826ecad02059a$export$22f379f031a59eaa;
module.exports["withContentOwnershipContextProvider"] = $30c826ecad02059a$export$e047c3e72baa9533;
module.exports["useContentOwnershipContext"] = $30c826ecad02059a$export$1e71db018b220386;
module.exports["ContentOwnershipContextConsumer"] = $30c826ecad02059a$export$d8bfa07cf352465c;

});

parcelRegister("kuujH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $5f4da457b317160c$var$i18nBase = (0, $kSwu1.defineMessages)({
    modalTitleEnabledForAllContent: {
        id: "content-ownership.content-header.owner-modal.title-enabled-for-all-content",
        defaultMessage: "Change owner"
    },
    modalBodyEnabledForAllContent: {
        id: "content-ownership.content-header.owner-modal.body-enabled-for-all-content",
        defaultMessage: "Choose a new owner"
    },
    modalCurrentOwner: {
        id: "content-ownership.content-header.owner-modal.current-owner",
        defaultMessage: "Current owner"
    },
    modalCancel: {
        id: "content-ownership.content-header.owner-modal.cancel-button",
        defaultMessage: "Cancel"
    },
    modalChangeOwner: {
        id: "content-ownership.content-header.owner-modal.change-owner-button",
        defaultMessage: "Change owner"
    },
    confirmModalTitle: {
        id: "content-ownership.content-header.confirm-owner-modal.title",
        defaultMessage: "Confirm this ownership transfer?"
    },
    confirmModalBody: {
        id: "content-ownership.content-header.confirm-owner-modal.body",
        defaultMessage: "Once you transfer ownership of this content, only an admin or the new owner can reverse it. <button>Learn more</button>"
    },
    confirmModalCancel: {
        id: "content-ownership.content-header.confirm-owner-modal.cancel-button",
        defaultMessage: "Cancel"
    },
    confirmModalConfirmChangeOwner: {
        id: "content-ownership.content-header.confirm-owner-modal.confirm-change-owner-button",
        defaultMessage: "Continue"
    },
    confirmModalCurrentOwner: {
        id: "content-ownership.content-header.confirm-owner-modal.current-owner",
        defaultMessage: "Current owner"
    },
    confirmModalNewOwner: {
        id: "content-ownership.content-header.confirm-owner-modal.new-owner",
        defaultMessage: "New owner"
    },
    bylineButtonTooltip: {
        id: "content-ownership.byline-button.tooltip",
        defaultMessage: "Manage ownership"
    },
    bylineButtonTooltipReadOnly: {
        id: "content-ownership.byline-button.tooltip.read.only",
        defaultMessage: "More details"
    },
    popupTriggerLabel: {
        id: "content-ownership.byline-popup.trigger-label",
        defaultMessage: "Manage ownership"
    },
    popupChangeOwnerButton: {
        id: "content-ownership.byline-popup.change-owner-button",
        defaultMessage: "Change owner"
    },
    popupCreatedBy: {
        id: "content-ownership.byline-popup.created-by",
        defaultMessage: "Created by <b>{user}</b> on {date}"
    },
    popupCreatedByUnknownDate: {
        id: "content-ownership.byline-popup.created-by.unknown-date",
        defaultMessage: "Created by <b>{user}</b> on unknown date"
    },
    popupLastOwnedBy: {
        id: "content-ownership.byline-popup.last-owned-by",
        defaultMessage: "Last owned by <b>{user}</b>"
    },
    changeWarningTitle: {
        id: "content-ownership.change-warning-dialog.title",
        defaultMessage: "This change can\u2019t be reversed"
    },
    changeWarningBody: {
        id: "content-ownership.change-warning-dialog.body",
        defaultMessage: "Once you transfer ownership to someone else, you won\u2019t be able to reverse it."
    },
    changeWarningCancel: {
        id: "content-ownership.change-warning-dialog.cancel-button",
        defaultMessage: "Cancel"
    },
    changeWarningContinue: {
        id: "content-ownership.change-warning-dialog.continue-button",
        defaultMessage: "Continue"
    },
    bylineMainText: {
        id: "content-ownership.byline.main-text",
        defaultMessage: "Owned by {user}"
    },
    abbreviatedBylineMainText: {
        id: "content-ownership.byline.abbreviated-main-text",
        defaultMessage: "By {user}"
    },
    bylineMainTextCreatedByConfluence: {
        id: "content-ownership.byline.main-text.created-by-confluence",
        defaultMessage: "Owned by {user}, created by Confluence"
    },
    abbreviatedBylineOwnerMessage: {
        id: "content-ownership.byline.abbreviated-owner-message",
        defaultMessage: "Owner"
    },
    bylineMainTextWithTemplate: {
        id: "content-ownership.byline.main-text.with-template",
        defaultMessage: "Owned by {user}, created {withTemplate}"
    },
    ownerWithContributorsDropdownTooltip: {
        id: "content-ownership.byline.owner-with-contributors-dropdown.tooltip",
        defaultMessage: "View owner and contributors"
    },
    ownerDropdownTooltip: {
        id: "content-ownership.byline.owner-dropdown.tooltip",
        defaultMessage: "View owner"
    },
    ownerRestrictionTitle: {
        id: "content-ownership.owner.restriction.title",
        defaultMessage: "This person doesn\u2019t have edit access"
    },
    ownerRestrictionMessage: {
        id: "content-ownership.owner.restriction.message",
        defaultMessage: "To grant them ownership, you must first give them edit access to this content."
    },
    manageRestrictionButton: {
        id: "content-ownership.manage.restriction.button",
        defaultMessage: "Manage access"
    },
    ownerParentPageRestrictionTitle: {
        id: "content-ownership.owner.parent.page.restriction.title",
        defaultMessage: "This person doesn\u2019t have edit access to this content and/or its parent."
    },
    ownerParentPageRestrictionMessage: {
        id: "content-ownership.owner.parent.page.restriction.message",
        defaultMessage: "To grant them ownership, you must provide them edit access to this and any necessary parent items."
    },
    manageParentPageRestrictionButton: {
        id: "content-ownership.manage.parent.page.restriction.button",
        defaultMessage: "Learn more"
    },
    ownerPremiumRestrictionTitle: {
        id: "content-ownership.owner.premium.restriction.title",
        defaultMessage: "This person doesn\u2019t have access to this content and/or parent content."
    },
    ownerPremiumRestrictionMessage: {
        id: "content-ownership.owner.premium.restriction.message",
        defaultMessage: "To grant them ownership, you must provide them edit access to this and any other necessary parent items."
    },
    managePremiumRestrictionButton: {
        id: "content-ownership.manage.premium.restriction.button",
        defaultMessage: "Inspect permissions"
    },
    ownerSpaceRestrictionTitle: {
        id: "content-ownership.owner.space.restriction.title",
        defaultMessage: "This person doesn\u2019t have access to this space"
    },
    ownerSpaceRestrictionMessage: {
        id: "content-ownership.owner.space.restriction.message",
        defaultMessage: "In order to grant them ownership, they must have access to this space."
    },
    manageSpaceRestrictionButton: {
        id: "content-ownership.manage.space.restriction.button",
        defaultMessage: "Contact space admins"
    },
    manageSpaceRestrictionButtonAdmin: {
        id: "content-ownership.manage.space.restriction.button.admin",
        defaultMessage: "Manage space permissions"
    },
    changeOwnerSpotlightTitle: {
        id: "content-ownership.change-owner.spotlight.title",
        defaultMessage: "Change who owns a page"
    },
    changeOwnerSpotlightBody: {
        id: "content-ownership.change-owner.spotlight.body",
        defaultMessage: "You (or your admin) can now transfer ownership of content to someone else."
    },
    changeOwnerSpotlightLearnMoreButton: {
        id: "content-ownership.change-owner.spotlight.learn-more-button",
        defaultMessage: "Learn more"
    },
    changeOwnerSpotlightOkButton: {
        id: "content-ownership.change-owner.spotlight.ok-button",
        defaultMessage: "OK"
    },
    requestSpacePermissionAdminEmailSubject: {
        id: "content-ownership.mailto.subject.space",
        defaultMessage: "[Confluence] A Confluence user needs space access"
    },
    requestSpacePermissionAdminEmailBody: {
        id: "content-ownership.mailto.body.space",
        defaultMessage: "Hi,%0D%0A%0D%0AI have someone who needs access to a space, but neither of us can change their access level. Can you take a look?%0D%0A%0D%0AThanks!%0D%0A{currentUser}%0D%0A%0D%0AUser who needs access:%0D%0A{requestedUser}%0D%0A%0D%0ALink to permissions for space \u201C{spaceName}\u201D:%0D%0A{spacePermissionsUrl}%0D%0A%0D%0ALink to content \u201C{pageTitle}\u201D:%0D%0A{pageUrl}"
    },
    successFlagMessage: {
        id: "content-ownership.change-owner.success-flag-message",
        defaultMessage: "Ownership transferred to {user}"
    },
    errorFlagMessage: {
        id: "content-ownership.change-owner.error-flag-message",
        defaultMessage: "Failed to transfer ownership"
    },
    recheckAccessFailedFlagMessage: {
        id: "content-ownership.change-owner.recheck-access-failed-flag-message",
        defaultMessage: "Couldn't confirm this person's access. Please try again."
    },
    closeModal: {
        id: "content-ownership.change-owner.close-modal-label",
        defaultMessage: "Close modal"
    },
    ownershipTransfer: {
        id: "content-ownership.ownership-transfer.arrow-right-icon",
        defaultMessage: "Ownership Transfer"
    },
    poweredByTemplates: {
        id: "content-ownership.powered-by-templates.byline.text",
        defaultMessage: "with a template"
    }
});
const $5f4da457b317160c$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    changeOwnerSpotlightTitle: {
        id: "content-ownership.change-owner.spotlight.title.livedocs",
        defaultMessage: "Change who owns a page or live doc"
    }
});
const $5f4da457b317160c$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($5f4da457b317160c$var$i18nBase, $5f4da457b317160c$var$i18nLiveDocs);
module.exports["i18n"] = $5f4da457b317160c$export$a7357cdd1f0b0168;

});

parcelRegister("74Ff0", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $gGK1T = parcelRequire("gGK1T");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $2E1L5 = parcelRequire("2E1L5");


var $68BwE = parcelRequire("68BwE");


var $jMyy4 = parcelRequire("jMyy4");

const $4e0f38e9e07b2bb1$export$d061690dfa4a74b7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId,
                limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $gGK1T.default), {
        ...t1,
        __callerPackage__: "content-ownership"
    });
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }
    let t2;
    if ($[2] !== data) {
        t2 = data ? (0, $68BwE.parseContributors)(data) : [];
        $[2] = data;
        $[3] = t2;
    } else t2 = $[3];
    const arrangedContributors = t2;
    return arrangedContributors;
} : ({ contentId: contentId })=>{
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $gGK1T.default), {
        variables: {
            contentId: contentId,
            limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
        },
        __callerPackage__: "content-ownership"
    });
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    // TODO: add analytics or experience tracking for errors
    }
    const arrangedContributors = (0, $cozmU.useMemo)(()=>data ? (0, $68BwE.parseContributors)(data) : [], [
        data
    ]);
    return arrangedContributors;
};
module.exports["useContentOwnershipContributors"] = $4e0f38e9e07b2bb1$export$d061690dfa4a74b7;

});

parcelRegister("68BwE", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $1ytiN = parcelRequire("1ytiN");


var $1kHsc = parcelRequire("1kHsc");


var $kuujH = parcelRequire("kuujH");


var $c0rhi = parcelRequire("c0rhi");

/**
 * @generated SignedSource<<7af19798b3fd1d7e6ae50e4aa14d3f83>>
 * @relayHash a36706bcb128501a5933a98fbda08020
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 87254643fc40b244325fdfa97a4b56bc6ccf22622fadff5eb337608fbb01d85b
const $d76d7f75124a4530$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "UserWithRestrictions",
            "kind": "LinkedField",
            "name": "userWithContentRestrictions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceEditPermission"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceViewPermission"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "restrictingContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "base"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnershipCheckRestrictionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnershipCheckRestrictionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a36706bcb128501a5933a98fbda08020",
            "id": "87254643fc40b244325fdfa97a4b56bc6ccf22622fadff5eb337608fbb01d85b",
            "metadata": {},
            "name": "ContentOwnershipCheckRestrictionsQuery",
            "operationKind": "query",
            "text": "query ContentOwnershipCheckRestrictionsQuery($accountId:String!,$contentId:ID!){userWithContentRestrictions(accountId:$accountId,contentId:$contentId){accountId,hasSpaceEditPermission,hasSpaceViewPermission,restrictingContent{id,links{webui,base}},operations{operation}}}"
        }
    };
}();
$d76d7f75124a4530$var$node.hash = "ee48824a057953005fb24fb90907119a";
var $d76d7f75124a4530$export$2e2bcd8739ae039 = $d76d7f75124a4530$var$node;


const $dd78442dc578dfc5$export$23cea6cd9905a69d = async (contentId, newOwnerId, fetchPolicy)=>{
    const result = {
        isUserRestricted: false,
        isSpaceRestricted: false,
        isParentPageRestricted: false,
        isEditPageRestricted: false
    };
    if (!contentId) return result;
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $d76d7f75124a4530$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            accountId: newOwnerId
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "content-ownership"
    });
    const restrictions = response?.data?.userWithContentRestrictions;
    if (!restrictions) // TODO: Could this happen? What should we do?
    return result;
    const operations = restrictions?.operations ?? [];
    const canEdit = operations.some((operationCheckResult)=>operationCheckResult?.operation === 'update');
    if (!canEdit) {
        // user is restricted on some level
        result.isUserRestricted = true;
        result.isEditPageRestricted = true;
    }
    // if there are space or parent page restrictions,
    // handle updating the warning state correctly
    if (!restrictions.hasSpaceEditPermission || restrictions.restrictingContent?.id) {
        // user is restricted on some level
        result.isUserRestricted = true;
        // check if user can edit in the space
        if (!restrictions.hasSpaceEditPermission) result.isSpaceRestricted = true;
        // check if the user is restricted on any parent content
        if (restrictions.restrictingContent?.id) result.isParentPageRestricted = true;
    }
    return result;
};
const $dd78442dc578dfc5$var$toUserProps = (graphqlUser)=>({
        id: graphqlUser?.accountId,
        name: graphqlUser?.displayName,
        avatarUrl: graphqlUser?.profilePicture?.path
    });
const $dd78442dc578dfc5$export$cb17140916749f02 = (data)=>{
    const content = data?.content?.nodes?.[0];
    const contributors = data?.contentContributors?.nodes?.map($dd78442dc578dfc5$var$toUserProps) || [];
    const lastModifier = $dd78442dc578dfc5$var$toUserProps(content?.version?.by);
    const owner = $dd78442dc578dfc5$var$toUserProps(content?.history?.ownedBy);
    return [
        // Owner is always shown first
        owner,
        // Then the last person to have edited, unless they're also the author
        ...lastModifier.id === owner.id ? [] : [
            lastModifier
        ],
        // Then all the other contributors
        ...contributors.filter(({ id: id })=>id !== owner.id && id !== lastModifier.id)
    ];
};
const $dd78442dc578dfc5$export$7c3fc15730a64f5a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
} : ()=>{
    return (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
};
const $dd78442dc578dfc5$export$36b45599d1b6a619 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
} : ()=>{
    return (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
};
const $dd78442dc578dfc5$export$c14d487d74629ccd = ({ intl: intl, spaceAdmins: spaceAdmins, spacePermissionsUrl: spacePermissionsUrl, spaceKey: spaceKey, contentId: contentId, requestedUser: requestedUser, currentUser: currentUser, pageTitle: pageTitle })=>{
    const spaceAdminsEmailList = spaceAdmins?.filter((admin)=>admin.email)?.map((admin)=>admin.email)?.join(',');
    const subject = intl.formatMessage((0, $kuujH.i18n).requestSpacePermissionAdminEmailSubject);
    const emailBodyProps = {
        spacePermissionsUrl: `${window.location.origin}${spacePermissionsUrl}`,
        requestedUser: requestedUser,
        currentUser: currentUser,
        pageTitle: pageTitle,
        pageUrl: `${window.location.origin}/spaces/${spaceKey}/pages/${contentId}`,
        spaceName: spaceKey
    };
    const body = intl.formatMessage((0, $kuujH.i18n).requestSpacePermissionAdminEmailBody, emailBodyProps);
    return `mailto:${spaceAdminsEmailList}?subject=${subject}&body=${body}`;
};
module.exports["checkIsUserRestricted"] = $dd78442dc578dfc5$export$23cea6cd9905a69d;
module.exports["parseContributors"] = $dd78442dc578dfc5$export$cb17140916749f02;
module.exports["useSPAViewContext"] = $dd78442dc578dfc5$export$7c3fc15730a64f5a;
module.exports["useExperienceTrackerContext"] = $dd78442dc578dfc5$export$36b45599d1b6a619;
module.exports["generateMailtoLink"] = $dd78442dc578dfc5$export$c14d487d74629ccd;

});

parcelRegister("5k5SG", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<657062f7e2223856bbd7922fe1b0be97>>
 * @relayHash fe7b6aeef2ff7293e4725ed5dae04ccf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58f5ebede16870335101f943d6d18dd3a91ef303ea41352c3fe3a851b3dafa33
const $dcb25824db19c666$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe7b6aeef2ff7293e4725ed5dae04ccf",
            "id": "58f5ebede16870335101f943d6d18dd3a91ef303ea41352c3fe3a851b3dafa33",
            "metadata": {},
            "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
            "operationKind": "query",
            "text": "query useIsSpaceOrSiteAdminSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$dcb25824db19c666$var$node.hash = "f2eac010f611ed87c98059843b20682c";
var $dcb25824db19c666$export$2e2bcd8739ae039 = $dcb25824db19c666$var$node;



var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $68BwE = parcelRequire("68BwE");


var $jMyy4 = parcelRequire("jMyy4");

const $b47c68511ddb148c$export$5197e7012247b053 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const [isSpaceAdmin, setIsSpaceAdmin] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $dcb25824db19c666$export$2e2bcd8739ae039), {
        ...t2,
        __callerPackage__: "content-ownership"
    });
    let t3;
    if ($[5] !== data?.space?.currentUser?.isAdmin) {
        t3 = ()=>{
            const isAdmin = data?.space?.currentUser?.isAdmin ?? false;
            setIsSpaceAdmin(isAdmin);
        };
        $[5] = data?.space?.currentUser?.isAdmin;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== data) {
        t4 = [
            data
        ];
        $[7] = data;
        $[8] = t4;
    } else t4 = $[8];
    (0, $cozmU.useEffect)(t3, t4);
    return isSiteAdmin || isSpaceAdmin;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const [isSpaceAdmin, setIsSpaceAdmin] = (0, $cozmU.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $dcb25824db19c666$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey,
        __callerPackage__: "content-ownership"
    });
    (0, $cozmU.useEffect)(()=>{
        const isAdmin = data?.space?.currentUser?.isAdmin ?? false;
        setIsSpaceAdmin(isAdmin);
    }, [
        data
    ]);
    return isSiteAdmin || isSpaceAdmin;
};
module.exports["useIsSpaceOrSiteAdmin"] = $b47c68511ddb148c$export$5197e7012247b053;

});

parcelRegister("2Oud5", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $e2788db33f615ba0$export$29633e5fddc10d17 = (key)=>{
    try {
        const cachedContentTimestampPairs = (0, $17wUi.confluenceLocalStorageInstance).getItem(key) ?? '';
        return cachedContentTimestampPairs?.split(',').reduce((acc, entry)=>{
            if (!entry) return acc;
            const [contentId, timestamp] = entry.split(':');
            if (contentId && timestamp) acc.push([
                contentId,
                Number(timestamp)
            ]);
            return acc;
        }, []);
    } catch  {
        // ToDo: Emit operational error analytic
        return [];
    }
};
const $e2788db33f615ba0$export$ccb7f4e8765d6456 = (entries, key)=>{
    try {
        const filteredEntries = entries.flatMap((entry)=>entry[0] && entry[1] && typeof entry[0] === 'string' && typeof entry[1] === 'number' ? [
                entry.join(':')
            ] : []);
        if (filteredEntries.length) (0, $17wUi.confluenceLocalStorageInstance).setItem(key, filteredEntries.join(','));
        else (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
    } catch  {
    // ToDo: Emit operational analytic event
    }
};
const $e2788db33f615ba0$export$3b0244bd9f8f568e = (contentId, key)=>{
    const cache = $e2788db33f615ba0$export$29633e5fddc10d17(key);
    const cachedEntry = cache.find(([cachedId])=>cachedId === contentId);
    const timestamp = cachedEntry?.[1] ?? 0;
    return timestamp;
};
const $e2788db33f615ba0$export$f57463674d9b9177 = (contentId, key, /** If no condition is provided, then we remove without asking questions */ condition)=>{
    const cache = $e2788db33f615ba0$export$29633e5fddc10d17(key);
    const cachedTupleIndex = cache.findIndex((entry)=>entry[0] === contentId);
    const cachedTuple = cachedTupleIndex > -1 ? cache[cachedTupleIndex] : null;
    const cachedTimestamp = cachedTuple?.[1] ?? 0;
    const shouldRemove = condition ? condition(cachedTimestamp) : true;
    if (shouldRemove) {
        const cleanedCache = cache.filter(([cachedId])=>cachedId !== contentId);
        $e2788db33f615ba0$export$ccb7f4e8765d6456(cleanedCache, key);
    }
};
const $e2788db33f615ba0$export$6f3d0a17746d454e = (contentId, timestamp, key, /** If no condition is provided, then we set without asking questions */ condition)=>{
    const shouldSet = condition ? condition(timestamp) : true;
    if (shouldSet) {
        const cache = $e2788db33f615ba0$export$29633e5fddc10d17(key);
        const cachedTupleIndex = cache.findIndex((entry)=>entry[0] === contentId);
        const updatedEntry = [
            contentId,
            timestamp
        ];
        if (cachedTupleIndex === -1) cache.push(updatedEntry);
        else cache[cachedTupleIndex] = updatedEntry;
        $e2788db33f615ba0$export$ccb7f4e8765d6456(cache, key);
    }
};
module.exports["getCachedTimestamp"] = $e2788db33f615ba0$export$3b0244bd9f8f568e;
module.exports["removeCachedTuple"] = $e2788db33f615ba0$export$f57463674d9b9177;
module.exports["setCachedTuple"] = $e2788db33f615ba0$export$6f3d0a17746d454e;

});

parcelRegister("Qy97i", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $24dy7 = parcelRequire("24dy7");


var $4efpo = parcelRequire("4efpo");


var $3cW6b = parcelRequire("3cW6b");


var $krxYo = parcelRequire("krxYo");


var $lpNn5 = parcelRequire("lpNn5");


var $5izWN = parcelRequire("5izWN");

const $e65d026078d2a5b9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    share: {
        id: "share-and-restrict-dialog.controlled-share-button.share",
        defaultMessage: "Share"
    },
    shareArialLabel: {
        id: "share-and-restrict-dialog.controlled-share-button.share-aria-label",
        defaultMessage: "Share, {tooltipMessage}"
    }
});
// Adapts ConfluenceLogoIcon (SVG) to the Atlaskit icon interface expected by Button iconBefore.
const $e65d026078d2a5b9$var$ConfluenceLogoIconWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { color: color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5izWN.ConfluenceLogoIcon), {
            color: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($3cW6b))),
    restricted: (0, (/*@__PURE__*/$parcel$interopDefault($4efpo))),
    public: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
    internal: $e65d026078d2a5b9$var$ConfluenceLogoIconWrapper
};
const $e65d026078d2a5b9$var$makeIconProps = (icon, isDisabled)=>{
    if (isDisabled) return {
        color: "var(--ds-icon-disabled, #080F214A)"
    };
    switch(icon){
        case 'error':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        case 'restricted':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        default:
            return {
                color: "var(--ds-icon-subtle, #505258)"
            };
    }
};
const $e65d026078d2a5b9$export$f939f151d984bfc = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { icon: icon, onClick: onClick, tooltipMessage: tooltipMessage, isDisabled: isDisabled, children: children, focusRef: focusRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const Icon = $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT[icon];
    let t1;
    if ($[0] !== icon || $[1] !== isDisabled) {
        t1 = $e65d026078d2a5b9$var$makeIconProps(icon, isDisabled);
        $[0] = icon;
        $[1] = isDisabled;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = {
            label: "",
            ...t1
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const iconProps = t2;
    let t3;
    if ($[5] !== formatMessage || $[6] !== tooltipMessage) {
        t3 = formatMessage(tooltipMessage);
        $[5] = formatMessage;
        $[6] = tooltipMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== children) {
        t4 = ()=>!children;
        $[8] = children;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== Icon || $[11] !== iconProps) {
        t5 = (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                ...parentProps,
                ...iconProps,
                size: "medium"
            });
        $[10] = Icon;
        $[11] = iconProps;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== formatMessage || $[14] !== tooltipMessage) {
        t6 = formatMessage($e65d026078d2a5b9$export$a7357cdd1f0b0168.shareArialLabel, {
            tooltipMessage: formatMessage(tooltipMessage)
        });
        $[13] = formatMessage;
        $[14] = tooltipMessage;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e65d026078d2a5b9$export$a7357cdd1f0b0168.share);
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== children || $[18] !== focusRef || $[19] !== isDisabled || $[20] !== onClick || $[21] !== t5 || $[22] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: t5,
            onClick: onClick,
            "aria-label": t6,
            isDisabled: isDisabled,
            ref: focusRef,
            testId: "controlled-share-button"
        }, children, t7);
        $[17] = children;
        $[18] = focusRef;
        $[19] = isDisabled;
        $[20] = onClick;
        $[21] = t5;
        $[22] = t6;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t3 || $[25] !== t4 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t3,
            position: "bottom",
            canAppear: t4,
            hideTooltipOnMouseDown: true,
            ignoreTooltipPointerEvents: true,
            delay: 100
        }, t8);
        $[24] = t3;
        $[25] = t4;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
module.exports["i18n"] = $e65d026078d2a5b9$export$a7357cdd1f0b0168;
module.exports["ControlledShareButton"] = $e65d026078d2a5b9$export$f939f151d984bfc;

});


//# sourceMappingURL=MainButtons.b5c6fce2.js.map
